// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2_esbuild@0.25.12_webpack-cli@6.0.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2_esbuild@0.25.12_webpack-cli@6.0.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*================================================================================
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Version: 2.0
	Author: PIXINVENT
	Author URL: http://www.themeforest.net/user/pixinvent
================================================================================

NOTE:
------
PLACE HERE YOUR OWN SCSS CODES AND IF NEEDED, OVERRIDE THE STYLES FROM THE OTHER STYLESHEETS.
WE WILL RELEASE FUTURE UPDATES SO IN ORDER TO NOT OVERWRITE YOUR STYLES IT'S BETTER LIKE THIS.  */
.quarterCol {
  padding: 10px 25px;
}

.dx-widget {
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
}

.dx-badge {
  background-color: #ff0000;
  color: white;
  border-radius: 50%;
  padding: 4px;
  width: 12px;
  height: 12px;
  font-size: 16px;
  margin-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: unset;
}

.quarterCol > .row {
  height: 100%;
  border-radius: 10px;
  padding-bottom: 10px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  box-shadow: 0px 0px 8px #d9d9d9;
}

.quarterColDividerContainer {
  text-align: center;
  height: 40px;
  align-items: center;
}

.quarterColDivider {
  color: lightgrey;
}

.quarterColDivider .horizontal {
  width: 75%;
  padding: "15px 30px";
  margin: "15px 30px";
}

.icon-info {
  content: "ⓘ";
}

.dx-radiobutton-icon:before {
  transform: scale(0.7);
  margin: auto;
}

.dx-radiobutton-icon-checked .dx-radiobutton-icon-dot {
  transform: scale(0.7);
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
}

.fulfillmentNavButton > .dx-button-content {
  padding: 5px 10px;
}

.app-footer {
  justify-content: right;
}

.smart-grid {
  width: auto;
  height: auto;
}

.smart-grid-command-item {
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  align-items: center;
}

.danger-color {
  color: #de3f3f;
}

.paginated-checkbox-select,
.checkbox-header-cell {
  width: 39px;
}

ul {
  list-style-type: none;
  padding-inline-start: 0;
}

.error {
  color: red;
  font-weight: bold;
}

.btn-left-space {
  margin-left: 4px;
}

.btn-right-space {
  margin-right: 4px;
}

.show-logo {
  max-height: 50px;
  padding-right: 20px;
}

.inline-block {
  display: inline-block;
}

label {
  font-weight: 600;
}

.page_list_item {
  background: white;
  border: 1px solid #c8ced3;
}

.lifted {
  display: table;
  background: lightgray;
}

.grip_icon {
  display: flex;
}
.grip_icon i {
  width: 6px;
}

.card-header .tooltip_label label {
  color: inherit;
}
.card-header .btn-link {
  color: inherit;
}
.card-header h4 {
  color: inherit;
}

.tooltip_label {
  display: flex;
  align-items: center;
}
.tooltip_label label {
  margin-right: 6px;
}
.tooltip_label i {
  margin-bottom: 7px;
}

.tooltip_checkbox {
  display: inline-flex;
  align-items: center;
}
.tooltip_checkbox span {
  margin-right: 6px;
}
.tooltip_checkbox i {
  margin-bottom: 3px;
}

.tooltip_text {
  max-width: 250px;
  font-weight: 400;
}

.breadcrumb-container {
  position: fixed;
  width: 100%;
  z-index: 9;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  background-color: #3a4248;
  border: none;
}

.breadcrumb-root {
  position: absolute;
  left: calc(100% - 400px);
  top: 0px;
  font-weight: 600;
  padding-top: 10px;
  width: 200px;
  text-align: center;
  background: #20a8d8;
}

.mf-card {
  border: none;
  box-shadow: 1px 1px 12px #b9b9b9;
}

.card {
  margin-bottom: 0.875rem;
  margin-top: 0.875rem;
}

.card-for-credit {
  margin-bottom: 0.2625rem;
  min-height: 500px;
}

.login-page {
  min-height: 100vh;
}

.dark-layout .login-card h1 {
  color: #676d7d;
}

.dark-layout .login-page {
  background-color: #2b2a33 !important;
}

.dark-layout .sign-in-input {
  background-color: #e8f0fe !important;
  color: #2b2a33 !important;
}

.sign-in-input {
  width: 100%;
}

.login-container {
  background-color: #1e1d2b;
}

.login-card {
  background-color: #fdfeff;
}
.login-card a {
  color: #5440d2;
}
.login-card a:hover {
  color: #3d2bb4;
}

.admin_login_logo {
  height: 100%;
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.admin_login_logo img {
  max-width: 200px;
  height: auto;
}

.card-password-form {
  display: flex;
}

.card-body-password-form {
  margin-top: 30px;
}

.login-divider-container {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 10px 0;
}

.login-divider-border {
  flex-grow: 1;
  height: 1px;
  background: #6e6b7b;
  margin: 0;
}

.login-divider-text {
  padding: 0 10px;
  color: #6e6b7b;
}

.full-width-button {
  width: 100%;
}

.token-button {
  background-color: darkgrey;
  color: default;
  border: none;
  height: 38px;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-top: 4px;
}
.token-button:hover, .token-button:focus, .token-button:active {
  background: #808080 !important;
}

.login-button {
  background-color: #5440d2;
  border: none;
}
.login-button:hover, .login-button:active, .login-button:focus {
  background-color: #3d2bb4 !important;
}

.sso-button {
  border: none;
  background-color: #cfd0d2;
  height: 38px;
  color: black;
  margin-bottom: 10px;
}
.sso-button:hover, .sso-button:focus, .sso-button:active {
  background-color: #adaeb3 !important;
  color: black;
}

.google-signin-button img {
  cursor: pointer;
  height: 21px;
  margin: 0;
  padding-right: 10px;
}

.microsoft-signin-button img {
  cursor: pointer;
  max-height: 38px;
  margin: 0;
  padding-right: 10px;
}

.user-nav {
  min-width: 115px;
}

.dropdown-options {
  min-width: 190px;
  width: auto;
}

.simple-sku-menubar,
.simple-sku-form-breadcrumb {
  text-align: center;
  background-color: var(--mf-colors-bg);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border-right: 1px solid var(--mf-colors-neutral-50);
}

.simple-sku-menubar.active,
.simple-sku-form-breadcrumb.active {
  background-color: var(--mf-colors-neutral-50);
  font-weight: 900;
  text-decoration: underline;
}

.simple-sku-form-breadcrumb.active::before,
.simple-sku-form-breadcrumb.active::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-color: transparent;
  border-style: solid;
}

.simple-sku-form-link {
  width: calc(100% - 30px);
  height: 95%;
  background-color: #fff;
  color: grey;
}

.simple-sku-form-link:active {
  background-color: #20a8d8 !important;
  color: #fff !important;
}

.sku-form-warning-text {
  text-align: right;
  color: red;
  margin-top: 15px;
}

.sku-client-dropdown {
  margin-top: 15px;
}

.warehouse-list-info {
  margin-bottom: 0.875rem;
  margin-top: 2px;
  margin-left: 10px;
  margin-right: 5px;
  background-color: aliceblue;
}

.btn-info {
  color: #fff;
}

img {
  max-height: 240px;
  max-width: 100%;
  margin: 0 auto;
}

.app-container {
  width: 500px;
  margin: 30px auto;
}

.clear {
  clear: both;
}

.details,
.title {
  text-align: center;
}

.error {
  margin-top: 4px;
  color: red;
}

.red-text {
  color: red;
}

.has-error {
  border: 1px dotted red;
}

.image-container {
  align-items: center;
  display: flex;
  width: 85%;
  height: 80%;
  float: left;
  margin: 15px 10px 10px 37px;
  text-align: center;
  justify-content: "center";
}

.preview-container {
  height: 335px;
  width: 100%;
  margin-bottom: 10px;
}

.placeholder-preview {
  cursor: pointer;
}

.placeholder-preview,
.render-preview {
  text-align: center;
  background-color: #efebeb;
  height: 100%;
  width: 100%;
  border-radius: 5px;
}

.upload-container {
  cursor: pointer;
  height: 300px;
}

.jqx-fill-state-normal {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

.img-avatar,
.avatar > img,
.img-circle {
  max-width: 100%;
  height: auto;
  border-radius: 0;
}

.image-deletion {
  position: absolute;
  margin-left: -40px;
  margin-top: 4px;
  background: #fff;
}

.admin-buttons {
  background: #f0f3f5;
  border: 1px solid #c8ced3;
  border-radius: 0.21875rem;
  padding: 5px;
  float: left;
  margin: 6px 16px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.admin-buttons.col-12 {
  flex: 0 1 100%;
}

.admin-buttons .btn {
  margin-right: 10px;
  margin-bottom: 5px;
}

.product-actions {
  float: right;
}

.product-actions .btn {
  margin-right: 10px;
}

.product-actions .btn:last-child {
  margin-right: 0px;
}

.th-width {
  min-width: 300px;
}

.text-difference-portal {
  background-color: #4dbd74;
  color: #fff;
  padding-left: 5px;
  border-radius: 5px;
  font-weight: 700;
  font-size: 85%;
}

.text-difference-location {
  background-color: #ffc107;
  color: #23282c;
  padding-left: 5px;
  border-radius: 5px;
  font-size: 85%;
  font-weight: 700;
}

#spinner-overlay {
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 1030;
  background-color: rgba(0, 0, 0, 0.2);
}

.wrapper.menu-hide #spinner-overlay {
  width: 100%;
  left: 0;
}

.mf-loading-spinner {
  width: 5.25rem;
  height: 5.25rem;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 10000000;
  border-radius: 999px;
  border: 3px solid #5440d2;
  background-color: rgba(200, 200, 200, 0.6);
  -webkit-animation: sk-scaleout 1s infinite ease-out alternate;
  animation: sk-scaleout 1s infinite ease-out alternate;
}

.mf-loading-logo {
  -webkit-animation: logo-spin 1s infinite ease-out alternate;
  animation: logo-spin 1s infinite ease-out alternate;
  border-radius: 999px;
}

.simple-sku-form-link-row .simple-sku-form-links button.simple-sku-form-link.active {
  color: #ffffff;
  background-color: #21a8d8;
  border: none;
}

.simple-sku-form-link.btn-secondary:not(:disabled):not(.disabled).active {
  color: #ffffff !important;
  background-color: #21a8d8;
  border: none;
}

.container-fluid {
  margin-top: 60px;
}

.client-background {
  background: #caffc7;
}

.portal-background {
  background: #fdffc7;
}

.product-background {
  background: #f5c687;
}

.admin-background {
  background: #fbd2d9;
}

.location-background {
  background: #d3ccfd;
}

.label-column.col-md-6 {
  padding-top: 10px;
}

.new-menu-item {
  margin-bottom: 1.75rem;
}

.cat_box {
  width: 100%;
  height: auto;
  padding-left: 15px;
}
.cat_box .button_text {
  font-size: 20px;
  line-height: 28px;
}

.disabled_text {
  font-size: 10px;
}

.cat_prod_box {
  width: 100%;
  height: auto;
  padding-left: 15px;
}
.cat_prod_box p {
  font-size: 15px;
  line-height: 15px;
}

.card-header .dropdown button.btn-secondary {
  padding: 0px 10px;
  margin: 0 10px;
}

.configurable-option-img-avatar {
  width: 50px;
  height: 50px;
}

.basic-multi-select {
  color: black;
}

.badge {
  padding: 10px;
  margin-bottom: 5px;
}

.add-remove-modal-cont {
  margin-top: 15px;
  padding-right: 15px;
  padding-left: 30px;
}

.stock-col {
  padding-right: 5px;
  width: 50%;
}

.vertical-rule-col {
  width: 2%;
  flex: none;
}

.vertical-rule {
  height: 100%;
  width: 1px;
  background-color: #ebe9f1;
  margin-left: 20px;
  display: flex;
}

.on-hand-col {
  padding-top: 5px;
  padding-right: 5px;
  width: 24%;
  flex: none;
  padding-left: 100px;
}

.available-col {
  padding-top: 5px;
  padding-left: 45px;
  width: 24%;
  flex: none;
}

.reason-col {
  padding-left: 14px;
  padding-right: 28px;
}

.stock-error {
  width: 100%;
  margin-top: 0.21875rem;
  font-size: 0.749875rem;
  color: #de4827;
}

.reason-error {
  text-align: right;
}

.stock-hr {
  margin-right: 16px;
}

.stock-buttons {
  margin: 10px 16px 20px 0;
}

#all-stocks {
  padding: 0px !important;
}

#base-n-sub-sku-stocks {
  padding: 0px !important;
}

.product-at-stock-management-header {
  display: inline-flex;
  width: 340px;
}

.product-at-stock-management {
  display: inline-flex;
  width: 325px;
}

#stock-product-header .badge-primary {
  width: 150px;
}
#stock-product-header .badge-secondary {
  width: 150px;
}
#stock-product-header .badge-warning {
  width: 150px;
}

#stock-product-search-form .form-control {
  border: 1px solid #5d9ee0;
}

#stock-product-top-header {
  background-color: #fff;
  font-size: 16px;
  font-weight: bold;
  padding-left: 33px;
  border: 1px solid #ccc;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
#stock-product-top-header .top-header-column {
  display: inline-block;
  width: 150px;
  text-align: center;
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
#stock-product-top-header .top-header-column-sku {
  display: inline-block;
  width: 180px;
  text-align: center;
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}

.form-control-stock-search {
  padding: 0.4375rem 0.875rem;
  font-size: 13px;
  line-height: 0.5;
  border: 1px solid #ccc;
}

#base-n-sub-sku-stocks .card-header {
  padding-top: 0px;
  padding-bottom: 0px;
}

.top-bottom-padding {
  padding-top: 15px;
  padding-bottom: 15px;
}

.statement-header {
  background-color: #f0f3f5;
  text-align: right;
}

.credit {
  background-color: #c2e9ef;
  text-align: right;
}

.debit {
  background-color: #efcfb8;
  text-align: right;
}

.menu-example-container {
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 50px;
  border: 1px solid #000;
}

.menu-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu-example p {
  padding: 10px;
}

.menu-example-logo {
  width: 300px;
  height: auto;
  padding-top: 20px;
}

.no-decoration {
  color: #23282c;
}

.no-decoration:hover {
  color: #23282c;
  text-decoration: none;
}

.th-column-action {
  width: 25%;
  padding-bottom: 47px !important;
}

.td-column-action {
  width: 25%;
}

.th-column-sku {
  padding-bottom: 47px !important;
}

.card-header {
  color: var(--mf-colors-fg);
  background-color: var(--mf-colors-surface) !important;
  border-bottom: 5px solid var(--mf-colors-surface);
}
.card-header input {
  color: var(--mf-colors-fg);
}

[draggable] {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  /* Required to make elements draggable in old WebKit */
  -khtml-user-drag: element;
  -webkit-user-drag: element;
}

.child-product-table {
  padding: 15px;
}

.column {
  padding: 10px;
  margin-right: 5px;
  height: 30px;
  -webkit-box-shadow: inset 0 0 3px #000;
  -ms-box-shadow: inset 0 0 3px #000;
  box-shadow: inset 0 0 3px #000;
  text-align: left;
  cursor: move;
}
.column td {
  padding: 7px;
}

.child-product-table {
  border: none;
}

.child-table {
  width: 100%;
  min-height: 250px;
}

#child-product-table {
  width: 100%;
}

.child-table-over,
.group-dropzone-over {
  min-height: 250px;
  border: 2px dashed #000;
}

.user-cart-table tr td {
  color: #fff;
}

.group-bundle-body,
.group-dropzone {
  min-height: 250px;
}

.dropzone-item {
  padding: 7px;
}

.dropzone-cell {
  padding: 2px;
}

.selected-bundle-name {
  display: flex;
  justify-content: space-between;
}

.group-dropzone-select {
  margin: 5px;
}

.group-user-select {
  padding: 5px;
  margin: 5px 24px 0px 0px;
  border: 2px solid lightblue;
  border-radius: 3px;
  color: lightblue;
}

.preview-group-products {
  margin-left: 10px;
}

.preview-group-bundle,
.preview-individual-bundle {
  border: 1px solid #ccc;
  padding-left: 7px;
  padding-top: 7px;
  margin-top: 15px;
}
.preview-group-bundle h5,
.preview-individual-bundle h5 {
  margin-top: 7px;
}

.bundle-flag {
  color: #335269;
  border: 1px solid #335269;
  padding: 0.21875rem 0.4375rem;
  border-radius: 0.175rem;
  font-size: 0.6699175rem;
}

.table.bundleProducts {
  margin-top: 20px;
}

.formgroup-bundle {
  flex-direction: row !important;
  padding: 15px 5px 5px 5px;
}
.formgroup-bundle label {
  padding: 10px;
}

.bundle-product-table {
  display: flex;
  justify-content: space-between;
}

.bundle-table {
  padding: 8px;
  margin-bottom: 0px;
}

table td.bundle-table-cell {
  padding: 0;
}

.category-table {
  color: #5c6873;
  background-color: #e4e7ea;
  vertical-align: bottom;
  border: 2px solid #c8ced3;
  font-size: 15px;
  font-weight: bold;
  padding: 10px;
  margin: 0px;
}

.parent-category-list {
  background-color: white;
  border: 0.5px solid #c8ced3;
  padding: 15px 0px 7.5px 0px;
  margin: 0px;
  vertical-align: middle;
}

.child-category-list {
  background-color: #f4f4f4;
  border: 0.5px solid #c8ced3;
  padding: 15px 0px 7.5px 0px;
  margin: 0px;
  vertical-align: middle;
}

.modal-dialog {
  max-width: 90%;
  width: 90%;
}

.modal-dialog.modal-slim {
  width: 40%;
}

.sk-spinner-pulse.sk-spinner-green.sk-spinner-inline {
  width: 10%;
  height: 40px;
  position: relative;
  left: 0;
  top: 0;
  margin: 0px auto;
}

.form-group.d-inline {
  display: inline !important;
}

.purchase-order-new-product {
  max-width: 100%;
}

.code-generation {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 60px 0 60px 0;
}
.code-generation h3 {
  padding-bottom: 25px;
}

.top-form-po {
  width: 100%;
  background-color: white;
  border-radius: 4px;
  margin-bottom: 20px;
  border: 0.5px solid #c8ced3;
  margin-top: -1px;
  position: relative;
  padding-top: 10px;
}

.header-top-form-po {
  width: 100%;
  height: 40px;
  border-radius: 4px;
  border: 0.5px solid #c8ced3;
  padding-top: 11px;
  padding-left: 18px;
}

.total-product-price {
  width: 100%;
  text-align: right;
  background-color: white;
  padding: 8px 27px;
  font-weight: 700;
  border: 0.5px solid #c8ced3;
}

.discount-taxes-po {
  width: 100%;
  background-color: white;
  padding: 10px;
  margin-bottom: 5px;
}

.total-price {
  width: 100%;
  text-align: right;
  background-color: white;
  padding: 8px 27px;
  margin-bottom: 5px;
  font-weight: 700;
  border: 0.5px solid #c8ced3;
}

.po-bottom-fields {
  border: 0.5px solid #c8ced3;
  background-color: white;
  margin-bottom: 15px;
}

.product-table-po {
  margin-bottom: 0px !important;
}

.tr-header-style {
  background-color: #335169;
  color: white;
}

.po-creation-date {
  padding: 14px 1px 16px 16px;
}

.po-discount {
  background-color: white;
  padding: 10px;
  text-align: right;
  margin-bottom: 1px;
  padding-right: 27px;
  border: 0.5px solid #c8ced3;
}

.product-table-po .table-bordered tr td {
  padding: 5px;
}

.product-table-po .table-bordered tr td datafield {
  background-color: red;
}

.po-form .rw-dropdown-list.rw-widget {
  width: 300px;
}

.date-picker-po-edit .date-input {
  width: 180px;
  height: 33px;
  border-radius: 5px;
  border-width: thin;
}

.date-picker-po-edit .date-input-error {
  width: 180px;
  border-color: #ea5455;
  border-radius: 5px;
  border-width: 2px;
}

.goods-receipt-form {
  background-color: white;
}

/** Shipper HQ items */
.shipping-selected-names {
  padding: 7px;
  border: 1px solid black;
  border-radius: 4px;
  margin-right: 7px;
}

.shipping-selected-names-row {
  padding: 5px;
  line-height: 2.5;
}

.comparison-list {
  white-space: normal;
  text-align: left;
}

.po-list .react-bs-table table td,
.react-bs-table table th {
  white-space: initial;
}

.good-receipts-notes-PO-show {
  border: 0.5px solid #c8ced3;
  padding: 10px;
  margin-bottom: 20px;
}

.po-form-status {
  margin-bottom: 12px;
}

.td-header-error {
  color: red;
}

.suborder-tag-remove-btn {
  position: absolute;
  top: -20px;
  left: -20px;
}

.nav-bar-warning,
.nav-bar-warning a {
  margin: 0 auto !important;
  font-size: 30px !important;
  text-align: center !important;
  color: red !important;
}
.nav-bar-warning p,
.nav-bar-warning a p {
  margin-bottom: 0px !important;
}

.address_error {
  color: red;
}

.roleButton {
  margin-top: 10px;
}

.icon {
  padding: 4px;
}

.product-spec-component .form-group {
  padding: 5px 15px;
  margin-bottom: 0;
}

.field-group .field-option {
  margin-bottom: none !important;
}

.tier-price-box {
  border: 1px solid #e4e5e6;
  padding: 15px;
  border-radius: 5px;
}

.role-table .react-bs-table table td {
  white-space: normal !important;
}

.role-name {
  margin-right: 7px;
}

.price-configuration {
  display: flex;
  justify-content: space-between;
}

.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkbox-container .checkmark {
  position: absolute;
  top: -10px;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: white;
  border: 1px solid black;
}

.checkbox-container:hover input ~ .checkmark {
  background-color: #ccc;
}

.checkbox-container input:checked ~ .checkmark {
  background-color: #335269;
}

.checkbox-container :after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-container .checkmark:after {
  left: 7px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

#custom_css_block {
  max-width: 100%;
}

.portal-form {
  background-color: #ffffff !important;
}

.bundle-edit-name {
  font-size: 15px;
  width: 300px;
}

.bundle-edit-name-input {
  width: 300px;
  color: #000;
}

.bundle-edit-description-input {
  width: 300px;
}

.bundle-edit-description {
  margin-left: 5px;
}

.bundle-edit-descr-label {
  font-size: 15px;
  font-weight: bold;
}

.bundle-edit-filter {
  float: right;
  color: #000;
}

.bundle-edit-label {
  display: inline-block;
  width: 100px;
}

.bundle-group-new-edit {
  margin-bottom: 5px;
}
.bundle-group-new-edit input {
  width: 200px;
}

.bundle-product-disabled {
  background-color: #dcdcdc;
}
.bundle-product-disabled td {
  color: rgba(0, 0, 0, 0.3);
}

.bundle-group-disabled {
  background-color: #dcdcdc;
}
.bundle-group-disabled div span {
  color: rgba(0, 0, 0, 0.4);
}

.disabled-group-header {
  color: rgba(0, 0, 0, 0.4);
}

.bundle-group-body-disabled .bundle-edit-descr-label,
.bundle-group-body-disabled .bundle-edit-description,
.bundle-group-body-disabled th,
.bundle-group-body-disabled td {
  color: rgba(0, 0, 0, 0.4);
}

.icon-button-dimensions {
  background-color: #00a0dd !important;
  border-color: #00a0dd !important;
}

.icon-button-dimensions:hover {
  background-color: #0576a3 !important;
  border-color: #0576a3 !important;
}

.cell-left-aligned {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  padding-bottom: 2px !important;
  text-align: left !important;
  margin-right: 2px !important;
  margin-left: 4px !important;
  font-weight: normal !important;
  margin-left: 4px !important;
}

.custom-modal-style {
  width: 30%;
  margin: 0 auto;
}

.modal-title {
  width: 100%;
  padding: 5px;
}

.protected-button-left-space {
  margin-left: 10px !important;
}

.dx-toolbar.dx-widget.dx-popup-title {
  background: #00a0dd;
}

.dx-popup-title.dx-toolbar .dx-item.dx-toolbar-item.dx-toolbar-label {
  color: #fff;
  font-size: 20px;
  font-family: "Montserrat", Helvetica, Arial, serif;
}

.devex-column-vertical-align {
  vertical-align: middle !important;
  white-space: nowrap !important;
}

.dx-freespace-row {
  display: none !important;
}

.devex-grid-nodata-container {
  width: 95%;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fdfeff;
  padding: 4rem;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.devex-grid-nodata-container .devex-grid-nodata-container-copy {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
}

.card-header-light {
  color: #4e5154 !important;
  background-color: #f7f7f7 !important;
}

.card-header-white {
  color: #4e5154 !important;
  background-color: #fff !important;
}

.card-header-dark-blue {
  color: #dae1e7 !important;
  background-color: #3a4459 !important;
}

.dx-tabs-wrapper {
  background-color: #f7f7f7;
}

.dark-layout textarea.notes-input {
  color: #2e2b3b !important;
}

.modal-progress {
  position: absolute;
  width: 50%;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
}

.full-width {
  width: 100%;
}

.left-align {
  justify-content: flex-start;
  display: flex;
  align-items: center;
}

.right-align {
  justify-content: flex-end;
  display: flex;
  align-items: center;
}

.center-align {
  justify-content: center;
  display: flex;
  align-items: center;
}

.sweet-alert-confirm-btn,
.sweet-alert-confirm-btn:focus,
.sweet-alert-confirm-btn:active {
  color: #fff !important;
}

.sweet-alert-cancel-btn,
.sweet-alert-cancel-btn:focus,
.sweet-alert-cancel-btn:active {
  color: #00a0dd !important;
}

.sweetalert-wide {
  width: 500px !important;
}

.sweetalert-narrow {
  width: 280px !important;
}

.sweetalert-tag-inputs {
  padding: 0 25px;
}

.sweetalert-narrow > p {
  margin: 0 !important;
}

.dx-first-row.dx-last-col.dx-first-row.dx-first-row.dx-first-row > .dx-item-content .dx-box-item-content {
  background-color: blue !important;
  /* text-align: right!important; */
}

.align-right {
  text-align: right;
}

.duration {
  padding-top: 8px;
  color: #84858c;
}

.image-item {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.image-item:hover {
  transform: scale(1.05);
}

.image-item button {
  opacity: 0.7;
}

.image-item button:hover {
  opacity: 1;
}

html body .app.flex-row.align-items-center {
  height: 100vh;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  #root {
    display: flex;
    flex-direction: column;
  }
}
@-webkit-keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0);
  }
  100% {
    -webkit-transform: scale(1);
    opacity: 0;
  }
}
@keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0.95) translate(-50%, -50%);
    transform: scale(0.95) translate(-50%, -50%);
    opacity: 0.65;
  }
  100% {
    -webkit-transform: scale(1) translate(-50%, -50%);
    transform: scale(1) translate(-50%, -50%);
  }
}
@keyframes roll {
  0% {
    transform: translateX(-150%) rotate(0deg);
  }
  100% {
    transform: translateX(150%) rotate(360deg);
  }
}
@keyframes logo-spin {
  0% {
    transform: scale(0.85);
  }
  100% {
    transform: scale(0.8);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/style.scss","webpack://./src/assets/scss/_custom.scss","webpack://./src/@core/scss/base/bootstrap-extended/_variables.scss","webpack://./src/assets/scss/_ie-fix.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;;;;iGAAA;ACYA;EACE,kBAAA;ADCF;;ACEA;EACE,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;ADCF;;ACEA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;ADCF;;ACEA;EACE,YAAA;EAEA,mBAAA;EAGA,oBAAA;EAEA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,+BAAA;ADHF;;ACMA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;ADHF;;ACMA;EACE,gBAAA;ADHF;;ACMA;EACE,UAAA;EACA,oBAAA;EACA,mBAAA;ADHF;;ACUA;EACE,YAAA;ADPF;;ACUA;EAGE,qBAAA;EACA,YAAA;ADTF;;ACYA;EACE,qBAAA;EASA,6BAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;ADjBF;;ACoBA;EACE,iBAAA;ADjBF;;ACsBA;EACE,sBAAA;ADnBF;;ACsBA;EACE,WAAA;EACA,YAAA;ADnBF;;ACsBA;EACE,6EAAA;EACA,mBAAA;ADnBF;;ACsBA;EACE,cApHO;ADiGT;;ACsBA;;EAOE,WAAA;ADxBF;;AC2BA;EACE,qBAAA;EACA,uBAAA;ADxBF;;AC2BA;EACE,UAAA;EACA,iBAAA;ADxBF;;AC2BA;EACE,gBAAA;ADxBF;;AC0BA;EACE,iBAAA;ADvBF;;AC0BA;EACE,gBAAA;EACA,mBAAA;ADvBF;;AC0BA;EACE,qBAAA;ADvBF;;AC0BA;EACE,gBAAA;ADvBF;;AC0BA;EACE,iBAAA;EACA,yBAAA;ADvBF;;AC0BA;EACE,cAAA;EACA,qBAAA;ADvBF;;AC0BA;EACE,aAAA;ADvBF;ACyBE;EACE,UAAA;ADvBJ;;AC6BI;EACE,cAAA;AD1BN;AC6BE;EACE,cAAA;AD3BJ;AC6BE;EACE,cAAA;AD3BJ;;AC+BA;EACE,aAAA;EACA,mBAAA;AD5BF;AC8BE;EACE,iBAAA;AD5BJ;AC+BE;EACE,kBAAA;AD7BJ;;ACiCA;EACE,oBAAA;EACA,mBAAA;AD9BF;ACgCE;EACE,iBAAA;AD9BJ;ACiCE;EACE,kBAAA;AD/BJ;;ACmCA;EACE,gBAAA;EACA,gBAAA;ADhCF;;ACmCA;EACE,eAAA;EACA,WAAA;EACA,UAAA;ADhCF;;ACmCA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;ADhCF;;ACmCA;EACE,kBAAA;EACA,wBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EAEA,YAAA;EACA,kBAAA;EAEA,mBAAA;ADlCF;;ACqCA;EACE,YAAA;EACA,gCAAA;ADlCF;;ACqCA;EACE,uBAAA;EACA,oBAAA;ADlCF;;ACqCA;EACE,wBAAA;EACA,iBAAA;ADlCF;;ACqCA;EACE,iBAAA;ADlCF;;ACyCE;EACE,cAAA;ADtCJ;;AC0CA;EACE,oCAAA;ADvCF;;AC0CA;EACE,oCAAA;EACA,yBAAA;ADvCF;;AC0CA;EACE,WAAA;ADvCF;;AC8CA;EACE,yBCpRc;AFyOhB;;AC8CA;EACE,yBCtSM;AF2PR;AC6CE;EACE,cC1RW;AF+Of;AC6CI;EACE,cC5Re;AFiPrB;;ACgDA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AD7CF;ACgDE;EACE,gBAAA;EACA,YAAA;AD9CJ;;ACkDA;EACE,aAAA;AD/CF;;ACkDA;EACE,gBAAA;AD/CF;;ACkDA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AD/CF;;ACkDA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;AD/CF;;ACkDA;EACE,eAAA;EACA,cAAA;AD/CF;;ACkDA;EACE,WAAA;AD/CF;;ACkDA;EACE,0BAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AD/CF;ACiDE;EAGE,8BAAA;ADjDJ;;ACqDA;EACE,yBClWa;EDmWb,YAAA;ADlDF;ACoDE;EAGE,oCAAA;ADpDJ;;ACwDA;EACE,YAAA;EACA,yBC3WQ;ED4WR,YAAA;EACA,YAAA;EACA,mBAAA;ADrDF;ACuDE;EAGE,oCAAA;EACA,YAAA;ADvDJ;;AC2DA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;ADxDF;;AC2DA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;ADxDF;;AC2DA;EACE,gBAAA;ADxDF;;AC2DA;EACE,gBAAA;EACA,WAAA;ADxDF;;AC4DA;;EAEE,kBAAA;EACA,qCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,mDAAA;ADzDF;;AC4DA;;EAEE,6CAAA;EACA,gBAAA;EACA,0BAAA;ADzDF;;AC4DA;;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;ADzDF;;ACoEA;EACE,wBAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;ADjEF;;ACoEA;EACE,oCAAA;EACA,sBAAA;ADjEF;;ACoEA;EACE,iBAAA;EACA,UAAA;EACA,gBAAA;ADjEF;;ACoEA;EACE,gBAAA;ADjEF;;ACoEA;EACE,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;ADjEF;;ACoEA;EACE,WAAA;ADjEF;;ACsEA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;ADnEF;;ACsEA;EACE,YAAA;EACA,iBAAA;ADnEF;;ACsEA;EACE,WAAA;ADnEF;;ACsEA;;EAEE,kBAAA;ADnEF;;ACsEA;EACE,eAAA;EACA,UAAA;ADnEF;;ACsEA;EACE,UAAA;ADnEF;;ACsEA;EACE,sBAAA;ADnEF;;ACsEA;EACE,mBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,2BAAA;EACA,kBAAA;EACA,yBAAA;ADnEF;;ACsEA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;ADnEF;;ACsEA;EACE,eAAA;ADnEF;;ACsEA;;EAEE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;ADnEF;;ACsEA;EACE,eAAA;EACA,aAAA;ADnEF;;ACsEA;EACE,6MACE;ADpEJ;;ACwEA;;;EAGE,eAAA;EACA,YAAA;EACA,gBAAA;ADrEF;;ACwEA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;ADrEF;;ACwEA;EACE,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;ADrEF;;ACwEA;EACE,cAAA;ADrEF;;ACwEA;EACE,kBAAA;EACA,kBAAA;ADrEF;;ACwEA;EACE,YAAA;ADrEF;;ACwEA;EACE,kBAAA;ADrEF;;ACwEA;EACE,iBAAA;ADrEF;;ACwEA;EACE,gBAAA;ADrEF;;ACwEA;EACE,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;ADrEF;;ACwEA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;ADrEF;;ACwEA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,oCAAA;ADrEF;;ACwEA;EACE,WAAA;EACA,OAAA;ADrEF;;ACwEA;EACE,cChGS;EDiGT,eCjGS;EDkGT,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,0CAAA;EAGA,6DAAA;EACA,qDAAA;ADvEF;;AC0EA;EAKE,2DAAA;EACA,mDAAA;EACA,oBAAA;AD3EF;;AC+EA;EACE,cAAA;EACA,yBAAA;EACA,YAAA;AD5EF;;AC+EA;EACE,yBAAA;EACA,yBAAA;EACA,YAAA;AD5EF;;ACoFA;EACE,gBAAA;ADjFF;;ACoFA;EACE,mBAAA;ADjFF;;ACoFA;EACE,mBAAA;ADjFF;;ACoFA;EACE,mBAAA;ADjFF;;ACoFA;EACE,mBAAA;ADjFF;;ACoFA;EACE,mBAAA;ADjFF;;ACoFA;EACE,iBAAA;ADjFF;;ACsFA;EACE,sBAAA;ADnFF;;ACsFA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ADnFF;ACqFE;EACE,eAAA;EACA,iBAAA;ADnFJ;;AC+FA;EACE,eAAA;AD5FF;;AC+FA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AD5FF;AC8FE;EACE,eAAA;EACA,iBAAA;AD5FJ;;ACgGA;EACE,iBAAA;EACA,cAAA;AD7FF;;ACkGA;EACE,WAAA;EACA,YAAA;AD/FF;;ACkGA;EACE,YAAA;AD/FF;;ACkGA;EACE,aAAA;EACA,kBAAA;AD/FF;;ACkGA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AD/FF;;ACkGA;EACE,kBAAA;EACA,UAAA;AD/FF;;ACkGA;EACE,SAAA;EACA,UAAA;AD/FF;;ACkGA;EACE,YAAA;EACA,UAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;AD/FF;;ACkGA;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,mBAAA;AD/FF;;ACkGA;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AD/FF;;ACkGA;EACE,kBAAA;EACA,mBAAA;AD/FF;;ACkGA;EACE,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,cAAA;AD/FF;;ACkGA;EACE,iBAAA;AD/FF;;ACkGA;EACE,kBAAA;AD/FF;;ACkGA;EACE,wBAAA;AD/FF;;ACkGA;EACE,uBAAA;AD/FF;;ACkGA;EACE,uBAAA;AD/FF;;ACoGA;EACE,oBAAA;EACA,YAAA;ADjGF;;ACoGA;EACE,oBAAA;EACA,YAAA;ADjGF;;ACqGE;EACE,YAAA;ADlGJ;ACqGE;EACE,YAAA;ADnGJ;ACsGE;EACE,YAAA;ADpGJ;;ACyGE;EACE,yBAAA;ADtGJ;;AC0GA;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;ADvGF;ACyGE;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,+BAAA;ADvGJ;AC0GE;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,+BAAA;ADxGJ;;AC4GA;EACE,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;ADzGF;;AC6GE;EACE,gBAAA;EACA,mBAAA;AD1GJ;;AC8GA;EACE,iBAAA;EACA,oBAAA;AD3GF;;AC8GA;EACE,yBAAA;EACA,iBAAA;AD3GF;;AC8GA;EACE,yBAAA;EACA,iBAAA;AD3GF;;AC8GA;EACE,yBAAA;EACA,iBAAA;AD3GF;;AC8GA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AD3GF;;AC8GA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AD3GF;AC6GE;EACE,aAAA;AD3GJ;;AC+GA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;AD5GF;;AC+GA;EACE,cAAA;AD5GF;;AC+GA;EACE,cAAA;EACA,qBAAA;AD5GF;;ACgHA;EACE,UAAA;EACA,+BAAA;AD7GF;;ACgHA;EACE,UAAA;AD7GF;;ACgHA;EACE,+BAAA;AD7GF;;ACgHA;EACE,0BAAA;EACA,qDAAA;EACA,iDAAA;AD7GF;AC+GE;EACE,0BAAA;AD7GJ;;ACqHA;EACE,sBAAA;EACA,wBAAA;EACA,yBAAA;EACA,iBAAA;EACA,sDAAA;EACA,yBAAA;EACA,0BAAA;ADlHF;;ACqHA;EACE,aAAA;ADlHF;;ACqHA;EACE,aAAA;EAEA,iBAAA;EAEA,YAAA;EACA,sCAAA;EACA,kCAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;ADpHF;ACsHE;EACE,YAAA;ADpHJ;;ACwHA;EACE,YAAA;ADrHF;;ACwHA;EACE,WAAA;EACA,iBAAA;ADrHF;;ACwHA;EACE,WAAA;ADrHF;;ACwHA;;EAEE,iBAAA;EACA,uBAAA;ADrHF;;ACwHA;EACE,WAAA;ADrHF;;ACwHA;;EAEE,iBAAA;ADrHF;;ACwHA;EACE,YAAA;ADrHF;;ACwHA;EACE,YAAA;ADrHF;;ACwHA;EACE,aAAA;EACA,8BAAA;ADrHF;;ACwHA;EACE,WAAA;ADrHF;;ACwHA;EACE,YAAA;EACA,wBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;ADrHF;;ACwHA;EACE,iBAAA;ADrHF;;ACwHA;;EAEE,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;ADrHF;ACuHE;;EACE,eAAA;ADpHJ;;ACwHA;EACE,cAAA;EACA,yBAAA;EACA,6BAAA;EACA,uBAAA;EACA,uBAAA;ADrHF;;ACwHA;EACE,gBAAA;ADrHF;;ACwHA;EACE,8BAAA;EACA,yBAAA;ADrHF;ACuHE;EACE,aAAA;ADrHJ;;ACyHA;EACE,aAAA;EACA,8BAAA;ADtHF;;ACyHA;EACE,YAAA;EACA,kBAAA;ADtHF;;ACyHA;EACE,UAAA;ADtHF;;ACyHA;EACE,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;ADtHF;;ACyHA;EACE,uBAAA;EAEA,2BAAA;EACA,2BAAA;EACA,WAAA;EACA,sBAAA;ADvHF;;AC0HA;EACE,yBAAA;EAEA,2BAAA;EACA,2BAAA;EACA,WAAA;EACA,sBAAA;ADxHF;;AC2HA;EACE,cAAA;EACA,UAAA;ADxHF;;AC2HA;EACE,UAAA;ADxHF;;AC2HA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,gBAAA;ADxHF;;AC2HA;EACE,0BAAA;ADxHF;;AC2HA;EACE,eAAA;ADxHF;;AC2HA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;ADxHF;AC0HE;EACE,oBAAA;ADxHJ;;AC4HA;EACE,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;ADzHF;;AC4HA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;ADzHF;;AC4HA;EACE,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;ADzHF;;AC4HA;EACE,WAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;ADzHF;;AC4HA;EACE,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;ADzHF;;AC4HA;EACE,2BAAA;EACA,uBAAA;EACA,mBAAA;ADzHF;;AC4HA;EACE,6BAAA;ADzHF;;AC4HA;EACE,yBAAA;EACA,YAAA;ADzHF;;AC4HA;EACE,2BAAA;ADzHF;;AC4HA;EACE,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;ADzHF;;AC4HA;EACE,YAAA;ADzHF;;AC4HA;EACE,qBAAA;ADzHF;;AC4HA;EACE,YAAA;ADzHF;;AC4HA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;ADzHF;;AC4HA;EACE,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;ADzHF;;AC8HA;EACE,uBAAA;AD3HF;;AC8HA,sBAAA;AAEA;EACE,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;AD5HF;;AC+HA;EACE,YAAA;EACA,gBAAA;AD5HF;;AC+HA;EACE,mBAAA;EACA,gBAAA;AD5HF;;AC+HA;;EAEE,oBAAA;AD5HF;;AC+HA;EACE,2BAAA;EACA,aAAA;EACA,mBAAA;AD5HF;;AC+HA;EACE,mBAAA;AD5HF;;ACgIA;EACE,UAAA;AD7HF;;ACgIA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AD7HF;;ACgIA;;EAEE,yBAAA;EACA,0BAAA;EACA,6BAAA;EACA,qBAAA;AD7HF;AC8HE;;EACE,6BAAA;AD3HJ;;AC+HA;EACE,UAAA;AD5HF;;AC+HA;EACE,gBAAA;AD5HF;;AC+HA;EACE,YAAA;AD5HF;;AC+HA;EACE,iBAAA;EACA,gBAAA;AD5HF;;AC+HA;EACE,8BAAA;AD5HF;;AC+HA;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;AD5HF;;AC+HA;EACE,8BAAA;AD5HF;;AC+HA;EACE,iBAAA;AD5HF;;AC+HA;EACE,aAAA;EACA,8BAAA;AD5HF;;AC+HA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AD5HF;AC8HE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AD5HJ;AC+HE;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,uBAAA;AD7HJ;;ACiIA;EACE,sBAAA;AD9HF;;ACiIA;EACE,yBAAA;AD9HF;;ACiIA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AD9HF;;ACiIA;EACE,cAAA;AD9HF;;ACiIA;EACE,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,4BAAA;EACA,wBAAA;AD9HF;;ACiIA;EACE,eAAA;AD9HF;;ACiIA;EACE,oCAAA;AD9HF;;ACiIA;EACE,eAAA;EACA,YAAA;AD9HF;;ACiIA;EACE,YAAA;EACA,WAAA;AD9HF;;ACiIA;EACE,YAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;ACiIA;EACE,eAAA;EACA,iBAAA;AD9HF;;ACiIA;EACE,YAAA;EACA,WAAA;AD9HF;;ACiIA;EACE,qBAAA;EACA,YAAA;AD9HF;;ACiIA;EACE,kBAAA;AD9HF;ACgIE;EACE,YAAA;AD9HJ;;ACkIA;EACE,yBAAA;AD/HF;ACiIE;EACE,yBAAA;AD/HJ;;ACmIA;EACE,yBAAA;ADhIF;ACkIE;EACE,yBAAA;ADhIJ;;ACoIA;EACE,yBAAA;ADjIF;;ACqIE;;;;EAIE,yBAAA;ADlIJ;;ACsIA;EACE,oCAAA;EACA,gCAAA;ADnIF;;ACsIA;EACE,oCAAA;EACA,gCAAA;ADnIF;;ACwIA;EACE,2BAAA;EACA,kCAAA;EACA,8BAAA;EACA,2BAAA;EACA,4BAAA;EACA,2BAAA;EACA,8BAAA;EACA,2BAAA;ADrIF;;AC0IA;EACE,UAAA;EACA,cAAA;ADvIF;;AC0IA;EACE,WAAA;EACA,YAAA;ADvIF;;ACiJA;EACE,4BAAA;AD9IF;;ACmJA;EACE,mBAAA;ADhJF;;ACoJA;EACE,WAAA;EACA,eAAA;EACA,kDAAA;ADjJF;;ACsJA;EACE,iCAAA;EACA,8BAAA;ADnJF;;ACsJA;EACE,wBAAA;ADnJF;;ACsJA;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBC1lDM;ED2lDN,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;ADnJF;;ACsJA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;ADnJF;;AC2JA;EACE,yBAAA;EACA,oCAAA;ADxJF;;AC2JA;EACE,yBAAA;EACA,iCAAA;ADxJF;;AC2JA;EACE,yBAAA;EACA,oCAAA;ADxJF;;AC2JA;EACE,yBAAA;ADxJF;;AC4JA;EACE,yBAAA;ADzJF;;AC4JA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;ADzJF;;AC4JA;EACE,WAAA;ADzJF;;AC4JA;EACE,2BAAA;EACA,aAAA;EACA,mBAAA;ADzJF;;AC4JA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;ADzJF;;AC4JA;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;ADzJF;;AC4JA;;;EAGE,sBAAA;ADzJF;;AC4JA;;;EAGE,yBAAA;ADzJF;;AC4JA;EACE,uBAAA;ADzJF;;AC4JA;EACE,uBAAA;ADzJF;;AC4JA;EACE,eAAA;ADzJF;;AC4JA;EACE,oBAAA;ADzJF;;AC4JA;EAEE,iCAAA;EACA,iCAAA;AD1JF;;AC6JA;EACE,iBAAA;AD1JF;;AC6JA;EACE,gBAAA;EACA,cAAA;AD1JF;;AC6JA;EACE,wCAAA;EACA,0BAAA;AD1JF;;AC6JA;EACE,sBAAA;AD1JF;;AC6JA;EACE,YAAA;AD1JF;;AC6JA;EACE,UAAA;AD1JF;;AG/kDA;EACE,aAAA;AHklDF;;AG9kDA;EACE;IACE,aAAA;IACA,sBAAA;EHilDF;AACF;AA7jDA;EACE;IACE,2BAAA;EA+jDF;EA7jDA;IACE,2BAAA;IACA,UAAA;EA+jDF;AACF;AA5jDA;EACE;IACE,oDAAA;IACA,4CAAA;IACA,aAAA;EA8jDF;EAhjDA;IACE,iDAAA;IACA,yCAAA;EAkjDF;AACF;AA/iDA;EACE;IACE,yCAAA;EAijDF;EA/iDA;IACE,0CAAA;EAijDF;AACF;AA9iDA;EACE;IACE,sBAAA;EAgjDF;EA9iDA;IACE,qBAAA;EAgjDF;AACF","sourcesContent":["/*================================================================================\n\tItem Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template\n\tVersion: 2.0\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n================================================================================\n\nNOTE:\n------\nPLACE HERE YOUR OWN SCSS CODES AND IF NEEDED, OVERRIDE THE STYLES FROM THE OTHER STYLESHEETS.\nWE WILL RELEASE FUTURE UPDATES SO IN ORDER TO NOT OVERWRITE YOUR STYLES IT'S BETTER LIKE THIS.  */\n\n// If you want to add something do it here\n@import 'custom';\n\n// ie fixes\n@import 'ie-fix';\n\n.spinner {\n  // width: 40px;\n  // height: 40px;\n  // margin: 100px auto;\n  // background-color: #333;\n\n  // border-radius: 100%;\n  // -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;\n  // animation: sk-scaleout 1.0s infinite ease-in-out;\n}\n\n@-webkit-keyframes sk-scaleout {\n  0% {\n    -webkit-transform: scale(0);\n  }\n  100% {\n    -webkit-transform: scale(1);\n    opacity: 0;\n  }\n}\n\n@keyframes sk-scaleout {\n  0% {\n    -webkit-transform: scale(0.95) translate(-50%, -50%);\n    transform: scale(0.95) translate(-50%, -50%);\n    opacity: 0.65;\n  }\n  // 30% {\n  //   -webkit-transform: rotate(45deg) translate(-50%, -50%);\n  //   transform: rotate(45deg) translate(-50%, -50%);\n  // }\n  // 50% {\n  //   -webkit-transform: rotate(-360deg) translate(-50%, -50%);\n  //   transform: rotate(-360deg) translate(-50%, -50%);\n  // }\n  // 70% {\n  //   -webkit-transform: rotate(0deg) translate(-50%, -50%);\n  //   transform: rotate(0deg) translate(-50%, -50%);\n  // }\n  100% {\n    -webkit-transform: scale(1) translate(-50%, -50%);\n    transform: scale(1) translate(-50%, -50%);\n  }\n}\n\n@keyframes roll {\n  0% {\n    transform: translateX(-150%) rotate(0deg);\n  }\n  100% {\n    transform: translateX(150%) rotate(360deg);\n  }\n}\n\n@keyframes logo-spin {\n  0% {\n    transform: scale(0.85);\n  }\n  100% {\n    transform: scale(0.8);\n  }\n}\n","// THIS IS THE GOOD CSS\n\n// @import 'variables';\n@import '../../@core/scss/base/bootstrap-extended/_variables.scss'; // Bootstrap custom variable override (for user purpose)\n\n// Here you can add other styles\n$danger: #de3f3f;\n\n// .hide-dx-button .dx-button {\n//   display: none;\n// }\n\n.quarterCol {\n  padding: 10px 25px;\n}\n\n.dx-widget {\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-border-radius: 4px;\n}\n\n.dx-badge {\n  background-color: #ff0000;\n  color: white;\n  border-radius: 50%;\n  padding: 4px;\n  width: 12px;\n  height: 12px;\n  font-size: 16px;\n  margin-left: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: unset;\n}\n\n.quarterCol > .row {\n  height: 100%;\n  // border: 1px solid lightgrey;\n  border-radius: 10px;\n  //background-color: lightgray;\n  //padding: 0px 15px 0px 15px;\n  padding-bottom: 10px;\n  //margin: 5px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  box-shadow: 0px 0px 8px #d9d9d9;\n}\n\n.quarterColDividerContainer {\n  text-align: center;\n  height: 40px;\n  align-items: center;\n}\n\n.quarterColDivider {\n  color: lightgrey;\n}\n\n.quarterColDivider .horizontal {\n  width: 75%;\n  padding: '15px 30px';\n  margin: '15px 30px';\n}\n\n.fulfillmentView .row div {\n  // padding-top: 5px;\n}\n\n.icon-info {\n  content: '\\24D8';\n}\n\n.dx-radiobutton-icon:before {\n  // width:10px;\n  // height:10px;\n  transform: scale(0.7);\n  margin: auto;\n}\n\n.dx-radiobutton-icon-checked .dx-radiobutton-icon-dot {\n  transform: scale(0.7);\n  //display: block;\n  //margin-top: -9px;\n  //margin-left: 4px;\n  //width: 5px;\n  //height: 5px;\n  //background: #337ab7;\n  //content: \"\";\n  //border-radius: 5px;\n  -webkit-transform: scale(0.7);\n  -moz-transform: scale(0.7);\n  -ms-transform: scale(0.7);\n  -o-transform: scale(0.7);\n}\n\n.fulfillmentNavButton > .dx-button-content {\n  padding: 5px 10px;\n  // margin: 0px;\n  // color: blue;\n}\n\n.app-footer {\n  justify-content: right;\n}\n\n.smart-grid {\n  width: auto;\n  height: auto;\n}\n\n.smart-grid-command-item {\n  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n  align-items: center;\n}\n\n.danger-color {\n  color: $danger;\n}\n\n.paginated-checkbox-select,\n.checkbox-header-cell {\n  // background-color: #FFF;\n  // display: flex;\n  // align-items: center;\n  // align-self: center;\n  // align-content: center;\n  width: 39px;\n}\n\nul {\n  list-style-type: none;\n  padding-inline-start: 0;\n}\n\n.error {\n  color: red;\n  font-weight: bold;\n}\n\n.btn-left-space {\n  margin-left: 4px;\n}\n.btn-right-space {\n  margin-right: 4px;\n}\n\n.show-logo {\n  max-height: 50px;\n  padding-right: 20px;\n}\n\n.inline-block {\n  display: inline-block;\n}\n\nlabel {\n  font-weight: 600;\n}\n\n.page_list_item {\n  background: white;\n  border: 1px solid #c8ced3;\n}\n\n.lifted {\n  display: table;\n  background: lightgray;\n}\n\n.grip_icon {\n  display: flex;\n\n  i {\n    width: 6px;\n  }\n}\n\n.card-header {\n  .tooltip_label {\n    label {\n      color: inherit;\n    }\n  }\n  .btn-link {\n    color: inherit;\n  }\n  h4 {\n    color: inherit;\n  }\n}\n\n.tooltip_label {\n  display: flex;\n  align-items: center;\n\n  label {\n    margin-right: 6px;\n  }\n\n  i {\n    margin-bottom: 7px;\n  }\n}\n\n.tooltip_checkbox {\n  display: inline-flex;\n  align-items: center;\n\n  span {\n    margin-right: 6px;\n  }\n\n  i {\n    margin-bottom: 3px;\n  }\n}\n\n.tooltip_text {\n  max-width: 250px;\n  font-weight: 400;\n}\n\n.breadcrumb-container {\n  position: fixed;\n  width: 100%;\n  z-index: 9;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  background-color: #3a4248;\n  border: none;\n}\n\n.breadcrumb-root {\n  position: absolute;\n  left: calc(100% - 400px);\n  top: 0px;\n  font-weight: 600;\n  padding-top: 10px;\n  // height: 45px;\n  width: 200px;\n  text-align: center;\n  // background: rgba(100, 100, 100, 0.1);\n  background: #20a8d8;\n}\n\n.mf-card {\n  border: none;\n  box-shadow: 1px 1px 12px #b9b9b9;\n}\n\n.card {\n  margin-bottom: remSizing(1);\n  margin-top: remSizing(1);\n}\n\n.card-for-credit {\n  margin-bottom: remSizing(0.3);\n  min-height: 500px;\n}\n\n.login-page {\n  min-height: 100vh;\n}\n\n.dark-layout .login-card {\n  // background color should not need to be overwritten here if the value remains the same\n  // background-color: $white;\n\n  h1 {\n    color: #676d7d;\n  }\n}\n\n.dark-layout .login-page {\n  background-color: #2b2a33 !important;\n}\n\n.dark-layout .sign-in-input {\n  background-color: #e8f0fe !important;\n  color: #2b2a33 !important;\n}\n\n.sign-in-input {\n  width: 100%;\n}\n\n// .card-boby-sku {\n//   background-color: #dcdbde;\n// }\n\n.login-container {\n  background-color: $brand-dark-bg;\n}\n\n.login-card {\n  background-color: $white;\n\n  a {\n    color: $brand-purple;\n\n    &:hover {\n      color: $brand-purple-hover;\n    }\n  }\n}\n\n.admin_login_logo {\n  height: 100%;\n  width: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  // padding-left: 100px;\n  img {\n    max-width: 200px;\n    height: auto;\n  }\n}\n\n.card-password-form {\n  display: flex;\n}\n\n.card-body-password-form {\n  margin-top: 30px;\n}\n\n.login-divider-container {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  margin: 10px 0;\n}\n\n.login-divider-border {\n  flex-grow: 1;\n  height: 1px;\n  background: #6e6b7b;\n  margin: 0;\n}\n\n.login-divider-text {\n  padding: 0 10px;\n  color: #6e6b7b;\n}\n\n.full-width-button {\n  width: 100%;\n}\n\n.token-button {\n  background-color: darkgrey;\n  color: default;\n  border: none;\n  height: 38px;\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 4px;\n\n  &:hover,\n  &:focus,\n  &:active {\n    background: #808080 !important;\n  }\n}\n\n.login-button {\n  background-color: $brand-purple;\n  border: none;\n\n  &:hover,\n  &:active,\n  &:focus {\n    background-color: $brand-purple-hover !important;\n  }\n}\n\n.sso-button {\n  border: none;\n  background-color: $sso-btn;\n  height: 38px;\n  color: black;\n  margin-bottom: 10px;\n\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: $sso-btn-hover !important;\n    color: black;\n  }\n}\n\n.google-signin-button img {\n  cursor: pointer;\n  height: 21px;\n  margin: 0;\n  padding-right: 10px;\n}\n\n.microsoft-signin-button img {\n  cursor: pointer;\n  max-height: 38px;\n  margin: 0;\n  padding-right: 10px;\n}\n\n.user-nav {\n  min-width: 115px;\n}\n\n.dropdown-options {\n  min-width: 190px;\n  width: auto;\n}\n\n//SKU SIMPLE FORM\n.simple-sku-menubar,\n.simple-sku-form-breadcrumb {\n  text-align: center;\n  background-color: var(--mf-colors-bg);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  border-right: 1px solid var(--mf-colors-neutral-50);\n}\n\n.simple-sku-menubar.active,\n.simple-sku-form-breadcrumb.active {\n  background-color: var(--mf-colors-neutral-50);\n  font-weight: 900;\n  text-decoration: underline;\n}\n\n.simple-sku-form-breadcrumb.active::before,\n.simple-sku-form-breadcrumb.active::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n// .simple-sku-form-breadcrumb.active::after {\n//   border-radius: 0em;\n//   border-width: 0.8em;\n//   border-right-color: #f0f3f5;\n//   border-bottom-color: #f0f3f5;\n//   border-top-color: #f0f3f5;\n// }\n\n.simple-sku-form-link {\n  width: calc(100% - 30px);\n  height: 95%;\n  background-color: #fff;\n  color: grey;\n}\n\n.simple-sku-form-link:active {\n  background-color: #20a8d8 !important;\n  color: #fff !important;\n}\n\n.sku-form-warning-text {\n  text-align: right;\n  color: red;\n  margin-top: 15px;\n}\n\n.sku-client-dropdown {\n  margin-top: 15px;\n}\n\n.warehouse-list-info {\n  margin-bottom: remSizing(1);\n  margin-top: 2px;\n  margin-left: 10px;\n  margin-right: 5px;\n  background-color: aliceblue;\n}\n\n.btn-info {\n  color: #fff;\n}\n\n//Single file drop Dropzone styling\n\nimg {\n  max-height: 240px;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.app-container {\n  width: 500px;\n  margin: 30px auto;\n}\n\n.clear {\n  clear: both;\n}\n\n.details,\n.title {\n  text-align: center;\n}\n\n.error {\n  margin-top: 4px;\n  color: red;\n}\n\n.red-text {\n  color: red;\n}\n\n.has-error {\n  border: 1px dotted red;\n}\n\n.image-container {\n  align-items: center;\n  display: flex;\n  width: 85%;\n  height: 80%;\n  float: left;\n  margin: 15px 10px 10px 37px;\n  text-align: center;\n  justify-content: 'center';\n}\n\n.preview-container {\n  height: 335px;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.placeholder-preview {\n  cursor: pointer;\n}\n\n.placeholder-preview,\n.render-preview {\n  text-align: center;\n  background-color: #efebeb;\n  height: 100%;\n  width: 100%;\n  border-radius: 5px;\n}\n\n.upload-container {\n  cursor: pointer;\n  height: 300px;\n}\n\n.jqx-fill-state-normal {\n  font-family:\n    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,\n    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji' !important;\n}\n\n.img-avatar,\n.avatar > img,\n.img-circle {\n  max-width: 100%;\n  height: auto;\n  border-radius: 0;\n}\n\n.image-deletion {\n  position: absolute;\n  margin-left: -40px;\n  margin-top: 4px;\n  background: #fff;\n}\n\n.admin-buttons {\n  background: #f0f3f5;\n  border: 1px solid #c8ced3;\n  border-radius: remSizing(0.25);\n  padding: 5px;\n  float: left;\n  margin: 6px 16px;\n  margin-bottom: 0px;\n  padding-bottom: 0px;\n}\n\n.admin-buttons.col-12 {\n  flex: 0 1 100%;\n}\n\n.admin-buttons .btn {\n  margin-right: 10px;\n  margin-bottom: 5px;\n}\n\n.product-actions {\n  float: right;\n}\n\n.product-actions .btn {\n  margin-right: 10px;\n}\n\n.product-actions .btn:last-child {\n  margin-right: 0px;\n}\n\n.th-width {\n  min-width: 300px;\n}\n\n.text-difference-portal {\n  background-color: #4dbd74;\n  color: #fff;\n  padding-left: 5px;\n  border-radius: 5px;\n  font-weight: 700;\n  font-size: 85%;\n}\n\n.text-difference-location {\n  background-color: #ffc107;\n  color: #23282c;\n  padding-left: 5px;\n  border-radius: 5px;\n  font-size: 85%;\n  font-weight: 700;\n}\n\n#spinner-overlay {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  top: 0;\n  z-index: 1030;\n  background-color: rgb(0, 0, 0, 0.2);\n}\n\n.wrapper.menu-hide #spinner-overlay {\n  width: 100%;\n  left: 0;\n}\n\n.mf-loading-spinner {\n  width: $space-24;\n  height: $space-24;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  z-index: 10000000;\n  border-radius: 999px;\n  border: 3px solid $brand-purple;\n  background-color: rgb(200, 200, 200, 0.6);\n\n  // margin: 100px auto;\n  -webkit-animation: sk-scaleout 1s infinite ease-out alternate;\n  animation: sk-scaleout 1s infinite ease-out alternate;\n}\n\n.mf-loading-logo {\n  // position: absolute;\n  // top: 50%;\n  // left: 50%;\n  // transform: translate(-50% -50%);\n  -webkit-animation: logo-spin 1s infinite ease-out alternate;\n  animation: logo-spin 1s infinite ease-out alternate;\n  border-radius: 999px;\n  // scale: 0.7;\n}\n\n.simple-sku-form-link-row .simple-sku-form-links button.simple-sku-form-link.active {\n  color: #ffffff;\n  background-color: #21a8d8;\n  border: none;\n}\n\n.simple-sku-form-link.btn-secondary:not(:disabled):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #21a8d8;\n  border: none;\n}\n\n// .completed-step {\n//   background: #169acac4;\n//   color: #fff;\n// }\n\n.container-fluid {\n  margin-top: 60px;\n}\n\n.client-background {\n  background: rgb(202, 255, 199);\n}\n\n.portal-background {\n  background: rgb(253, 255, 199);\n}\n\n.product-background {\n  background: rgb(245, 198, 135);\n}\n\n.admin-background {\n  background: rgb(251, 210, 217);\n}\n\n.location-background {\n  background: rgb(211, 204, 253);\n}\n\n.label-column.col-md-6 {\n  padding-top: 10px;\n}\n\n// CATEGORY STUFF\n\n.new-menu-item {\n  margin-bottom: remSizing(2);\n}\n\n.cat_box {\n  width: 100%;\n  height: auto;\n  padding-left: 15px;\n\n  .button_text {\n    font-size: 20px;\n    line-height: 28px;\n  }\n}\n\n// .box_disabled {\n//   background-color: #dcdbde;\n// }\n\n// .box-enabled {\n//   background-color: white;\n// }\n\n.disabled_text {\n  font-size: 10px;\n}\n\n.cat_prod_box {\n  width: 100%;\n  height: auto;\n  padding-left: 15px;\n\n  p {\n    font-size: 15px;\n    line-height: 15px;\n  }\n}\n\n.card-header .dropdown button.btn-secondary {\n  padding: 0px 10px;\n  margin: 0 10px;\n}\n\n// configurable option\n\n.configurable-option-img-avatar {\n  width: 50px;\n  height: 50px;\n}\n\n.basic-multi-select {\n  color: black;\n}\n\n.badge {\n  padding: 10px;\n  margin-bottom: 5px;\n}\n\n.add-remove-modal-cont {\n  margin-top: 15px;\n  padding-right: 15px;\n  padding-left: 30px;\n}\n\n.stock-col {\n  padding-right: 5px;\n  width: 50%;\n}\n\n.vertical-rule-col {\n  width: 2%;\n  flex: none;\n}\n\n.vertical-rule {\n  height: 100%;\n  width: 1px;\n  background-color: #ebe9f1;\n  margin-left: 20px;\n  display: flex;\n}\n\n.on-hand-col {\n  padding-top: 5px;\n  padding-right: 5px;\n  width: 24%;\n  flex: none;\n  padding-left: 100px;\n}\n\n.available-col {\n  padding-top: 5px;\n  padding-left: 45px;\n  width: 24%;\n  flex: none;\n}\n\n.reason-col {\n  padding-left: 14px;\n  padding-right: 28px;\n}\n\n.stock-error {\n  width: 100%;\n  margin-top: remSizing(0.25);\n  font-size: remSizing(0.857);\n  color: #de4827;\n}\n\n.reason-error {\n  text-align: right;\n}\n\n.stock-hr {\n  margin-right: 16px;\n}\n\n.stock-buttons {\n  margin: 10px 16px 20px 0;\n}\n\n#all-stocks {\n  padding: 0px !important;\n}\n\n#base-n-sub-sku-stocks {\n  padding: 0px !important;\n}\n\n//STOCK MANAGEMENT\n\n.product-at-stock-management-header {\n  display: inline-flex;\n  width: 340px;\n}\n\n.product-at-stock-management {\n  display: inline-flex;\n  width: 325px;\n}\n\n#stock-product-header {\n  .badge-primary {\n    width: 150px;\n  }\n\n  .badge-secondary {\n    width: 150px;\n  }\n\n  .badge-warning {\n    width: 150px;\n  }\n}\n\n#stock-product-search-form {\n  .form-control {\n    border: 1px solid #5d9ee0;\n  }\n}\n\n#stock-product-top-header {\n  background-color: #fff;\n  font-size: 16px;\n  font-weight: bold;\n  padding-left: 33px;\n  border: 1px solid #ccc;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n\n  .top-header-column {\n    display: inline-block;\n    width: 150px;\n    text-align: center;\n    padding-top: 15px !important;\n    padding-bottom: 15px !important;\n  }\n\n  .top-header-column-sku {\n    display: inline-block;\n    width: 180px;\n    text-align: center;\n    padding-top: 15px !important;\n    padding-bottom: 15px !important;\n  }\n}\n\n.form-control-stock-search {\n  padding: remSizing(0.5) remSizing(1);\n  font-size: 13px;\n  line-height: 0.5;\n  border: 1px solid #ccc;\n}\n\n#base-n-sub-sku-stocks {\n  .card-header {\n    padding-top: 0px;\n    padding-bottom: 0px;\n  }\n}\n\n.top-bottom-padding {\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n.statement-header {\n  background-color: #f0f3f5;\n  text-align: right;\n}\n\n.credit {\n  background-color: #c2e9ef;\n  text-align: right;\n}\n\n.debit {\n  background-color: #efcfb8;\n  text-align: right;\n}\n\n.menu-example-container {\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 50px;\n  border: 1px solid #000;\n}\n\n.menu-example {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  p {\n    padding: 10px;\n  }\n}\n\n.menu-example-logo {\n  width: 300px;\n  height: auto;\n  padding-top: 20px;\n}\n\n.no-decoration {\n  color: #23282c;\n}\n\n.no-decoration:hover {\n  color: #23282c;\n  text-decoration: none;\n}\n\n// bundle table styling\n.th-column-action {\n  width: 25%;\n  padding-bottom: 47px !important;\n}\n\n.td-column-action {\n  width: 25%;\n}\n\n.th-column-sku {\n  padding-bottom: 47px !important;\n}\n\n.card-header {\n  color: var(--mf-colors-fg);\n  background-color: $card-header-bg !important;\n  border-bottom: 5px solid $card-header-border;\n\n  input {\n    color: var(--mf-colors-fg);\n  }\n}\n\n// .draggable-item{\n//   background: red;\n// }\n\n[draggable] {\n  -moz-user-select: none;\n  -khtml-user-select: none;\n  -webkit-user-select: none;\n  user-select: none;\n  /* Required to make elements draggable in old WebKit */\n  -khtml-user-drag: element;\n  -webkit-user-drag: element;\n}\n\n.child-product-table {\n  padding: 15px;\n}\n\n.column {\n  padding: 10px;\n\n  margin-right: 5px;\n\n  height: 30px;\n  -webkit-box-shadow: inset 0 0 3px #000;\n  -ms-box-shadow: inset 0 0 3px #000;\n  box-shadow: inset 0 0 3px #000;\n  text-align: left;\n  cursor: move;\n\n  td {\n    padding: 7px;\n  }\n}\n\n.child-product-table {\n  border: none;\n}\n\n.child-table {\n  width: 100%;\n  min-height: 250px;\n}\n\n#child-product-table {\n  width: 100%;\n}\n\n.child-table-over,\n.group-dropzone-over {\n  min-height: 250px;\n  border: 2px dashed #000;\n}\n\n.user-cart-table tr td {\n  color: #fff;\n}\n\n.group-bundle-body,\n.group-dropzone {\n  min-height: 250px;\n}\n\n.dropzone-item {\n  padding: 7px;\n}\n\n.dropzone-cell {\n  padding: 2px;\n}\n\n.selected-bundle-name {\n  display: flex;\n  justify-content: space-between;\n}\n\n.group-dropzone-select {\n  margin: 5px;\n}\n\n.group-user-select {\n  padding: 5px;\n  margin: 5px 24px 0px 0px;\n  border: 2px solid lightblue;\n  border-radius: 3px;\n  color: lightblue;\n}\n\n.preview-group-products {\n  margin-left: 10px;\n}\n\n.preview-group-bundle,\n.preview-individual-bundle {\n  border: 1px solid #ccc;\n  padding-left: 7px;\n  padding-top: 7px;\n  margin-top: 15px;\n\n  h5 {\n    margin-top: 7px;\n  }\n}\n\n.bundle-flag {\n  color: #335269;\n  border: 1px solid #335269;\n  padding: remSizing(0.25) remSizing(0.5);\n  border-radius: remSizing(0.2);\n  font-size: remSizing(0.76562);\n}\n\n.table.bundleProducts {\n  margin-top: 20px;\n}\n\n.formgroup-bundle {\n  flex-direction: row !important;\n  padding: 15px 5px 5px 5px;\n\n  label {\n    padding: 10px;\n  }\n}\n\n.bundle-product-table {\n  display: flex;\n  justify-content: space-between;\n}\n\n.bundle-table {\n  padding: 8px;\n  margin-bottom: 0px;\n}\n\ntable td.bundle-table-cell {\n  padding: 0;\n}\n\n.category-table {\n  color: #5c6873;\n  background-color: #e4e7ea;\n  vertical-align: bottom;\n  border: 2px solid #c8ced3;\n  font-size: 15px;\n  font-weight: bold;\n  padding: 10px;\n  margin: 0px;\n}\n\n.parent-category-list {\n  background-color: white;\n  //vertical-align: bottom;\n  border: 0.5px solid #c8ced3;\n  padding: 15px 0px 7.5px 0px;\n  margin: 0px;\n  vertical-align: middle;\n}\n\n.child-category-list {\n  background-color: #f4f4f4;\n  //vertical-align: bottom;\n  border: 0.5px solid #c8ced3;\n  padding: 15px 0px 7.5px 0px;\n  margin: 0px;\n  vertical-align: middle;\n}\n\n.modal-dialog {\n  max-width: 90%;\n  width: 90%;\n}\n\n.modal-dialog.modal-slim {\n  width: 40%;\n}\n\n.sk-spinner-pulse.sk-spinner-green.sk-spinner-inline {\n  width: 10%;\n  height: 40px;\n  position: relative;\n  left: 0;\n  top: 0;\n  margin: 0px auto;\n}\n\n.form-group.d-inline {\n  display: inline !important;\n}\n\n.purchase-order-new-product {\n  max-width: 100%;\n}\n\n.code-generation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 60px 0 60px 0;\n\n  h3 {\n    padding-bottom: 25px;\n  }\n}\n\n.top-form-po {\n  width: 100%;\n  background-color: white;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  border: 0.5px solid #c8ced3;\n  margin-top: -1px;\n  position: relative;\n  padding-top: 10px;\n}\n\n.header-top-form-po {\n  width: 100%;\n  height: 40px;\n  border-radius: 4px;\n  border: 0.5px solid #c8ced3;\n  padding-top: 11px;\n  padding-left: 18px;\n}\n\n.total-product-price {\n  width: 100%;\n  text-align: right;\n  background-color: white;\n  padding: 8px 27px;\n  font-weight: 700;\n  border: 0.5px solid #c8ced3;\n}\n\n.discount-taxes-po {\n  width: 100%;\n  background-color: white;\n  padding: 10px;\n  margin-bottom: 5px;\n}\n\n.total-price {\n  width: 100%;\n  text-align: right;\n  background-color: white;\n  padding: 8px 27px;\n  margin-bottom: 5px;\n  font-weight: 700;\n  border: 0.5px solid #c8ced3;\n}\n\n.po-bottom-fields {\n  border: 0.5px solid #c8ced3;\n  background-color: white;\n  margin-bottom: 15px;\n}\n\n.product-table-po {\n  margin-bottom: 0px !important;\n}\n\n.tr-header-style {\n  background-color: #335169;\n  color: white;\n}\n\n.po-creation-date {\n  padding: 14px 1px 16px 16px;\n}\n\n.po-discount {\n  background-color: white;\n  padding: 10px;\n  text-align: right;\n  margin-bottom: 1px;\n  padding-right: 27px;\n  border: 0.5px solid #c8ced3;\n}\n\n.product-table-po .table-bordered tr td {\n  padding: 5px;\n}\n\n.product-table-po .table-bordered tr td datafield {\n  background-color: red;\n}\n\n.po-form .rw-dropdown-list.rw-widget {\n  width: 300px;\n}\n\n.date-picker-po-edit .date-input {\n  width: 180px;\n  height: 33px;\n  border-radius: 5px;\n  border-width: thin;\n}\n\n.date-picker-po-edit .date-input-error {\n  width: 180px;\n  border-color: #ea5455;\n  border-radius: 5px;\n  border-width: 2px;\n}\n\n//Goods receipts\n\n.goods-receipt-form {\n  background-color: white;\n}\n\n/** Shipper HQ items */\n\n.shipping-selected-names {\n  padding: 7px;\n  border: 1px solid black;\n  border-radius: 4px;\n  margin-right: 7px;\n}\n\n.shipping-selected-names-row {\n  padding: 5px;\n  line-height: 2.5;\n}\n\n.comparison-list {\n  white-space: normal;\n  text-align: left;\n}\n\n.po-list .react-bs-table table td,\n.react-bs-table table th {\n  white-space: initial;\n}\n\n.good-receipts-notes-PO-show {\n  border: 0.5px solid #c8ced3;\n  padding: 10px;\n  margin-bottom: 20px;\n}\n\n.po-form-status {\n  margin-bottom: 12px;\n  // margin-top: -13px;\n}\n\n.td-header-error {\n  color: red;\n}\n\n.suborder-tag-remove-btn {\n  position: absolute;\n  top: -20px;\n  left: -20px;\n}\n\n.nav-bar-warning,\n.nav-bar-warning a {\n  margin: 0 auto !important;\n  font-size: 30px !important;\n  text-align: center !important;\n  color: red !important;\n  p {\n    margin-bottom: 0px !important;\n  }\n}\n\n.address_error {\n  color: red;\n}\n\n.roleButton {\n  margin-top: 10px;\n}\n\n.icon {\n  padding: 4px;\n}\n\n.product-spec-component .form-group {\n  padding: 5px 15px;\n  margin-bottom: 0;\n}\n\n.field-group .field-option {\n  margin-bottom: none !important;\n}\n\n.tier-price-box {\n  border: 1px solid #e4e5e6;\n  padding: 15px;\n  border-radius: 5px;\n}\n\n.role-table .react-bs-table table td {\n  white-space: normal !important;\n}\n\n.role-name {\n  margin-right: 7px;\n}\n\n.price-configuration {\n  display: flex;\n  justify-content: space-between;\n}\n\n.checkbox-container {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n\n  .checkmark {\n    position: absolute;\n    top: -10px;\n    left: 0;\n    height: 20px;\n    width: 20px;\n    background-color: white;\n    border: 1px solid black;\n  }\n}\n\n.checkbox-container:hover input ~ .checkmark {\n  background-color: #ccc;\n}\n\n.checkbox-container input:checked ~ .checkmark {\n  background-color: #335269;\n}\n\n.checkbox-container :after {\n  content: '';\n  position: absolute;\n  display: none;\n}\n\n.checkbox-container input:checked ~ .checkmark:after {\n  display: block;\n}\n\n.checkbox-container .checkmark:after {\n  left: 7px;\n  top: 3px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n#custom_css_block {\n  max-width: 100%;\n}\n\n.portal-form {\n  background-color: #ffffff !important;\n}\n\n.bundle-edit-name {\n  font-size: 15px;\n  width: 300px;\n}\n\n.bundle-edit-name-input {\n  width: 300px;\n  color: #000;\n}\n\n.bundle-edit-description-input {\n  width: 300px;\n}\n\n.bundle-edit-description {\n  margin-left: 5px;\n}\n\n.bundle-edit-descr-label {\n  font-size: 15px;\n  font-weight: bold;\n}\n\n.bundle-edit-filter {\n  float: right;\n  color: #000;\n}\n\n.bundle-edit-label {\n  display: inline-block;\n  width: 100px;\n}\n\n.bundle-group-new-edit {\n  margin-bottom: 5px;\n\n  input {\n    width: 200px;\n  }\n}\n\n.bundle-product-disabled {\n  background-color: #dcdcdc;\n\n  td {\n    color: rgba(0, 0, 0, 0.3);\n  }\n}\n\n.bundle-group-disabled {\n  background-color: #dcdcdc;\n\n  div span {\n    color: rgba(0, 0, 0, 0.4);\n  }\n}\n\n.disabled-group-header {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.bundle-group-body-disabled {\n  .bundle-edit-descr-label,\n  .bundle-edit-description,\n  th,\n  td {\n    color: rgba(0, 0, 0, 0.4);\n  }\n}\n\n.icon-button-dimensions {\n  background-color: #00a0dd !important;\n  border-color: #00a0dd !important;\n}\n\n.icon-button-dimensions:hover {\n  background-color: #0576a3 !important;\n  border-color: #0576a3 !important;\n}\n\n// JQX GRID\n\n.cell-left-aligned {\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  padding-bottom: 2px !important;\n  text-align: left !important;\n  margin-right: 2px !important;\n  margin-left: 4px !important;\n  font-weight: normal !important;\n  margin-left: 4px !important;\n  // margin-top: 8px!important;\n}\n\n// DELETE MODAL\n.custom-modal-style {\n  width: 30%;\n  margin: 0 auto;\n}\n\n.modal-title {\n  width: 100%;\n  padding: 5px;\n}\n\n// DEVEX GRID COMPONENT\n// DEVEX ITEM --- Not working\n// .devex-datagrid-item {\n//   padding-right: 10px!important;\n//   margin-right: 10px!important;\n//   background-color: #335169!important;\n// }\n.protected-button-left-space {\n  margin-left: 10px !important;\n}\n\n// DEVEX POPUP\n// Title bg\n.dx-toolbar.dx-widget.dx-popup-title {\n  background: #00a0dd;\n}\n\n// title font\n.dx-popup-title.dx-toolbar .dx-item.dx-toolbar-item.dx-toolbar-label {\n  color: #fff;\n  font-size: 20px;\n  font-family: 'Montserrat', Helvetica, Arial, serif;\n}\n\n// DEVEX grid vertical column alighment\n\n.devex-column-vertical-align {\n  vertical-align: middle !important;\n  white-space: nowrap !important;\n}\n\n.dx-freespace-row {\n  display: none !important;\n}\n\n.devex-grid-nodata-container {\n  width: 95%;\n  position: absolute;\n  top: 60%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: $white;\n  padding: 4rem;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.devex-grid-nodata-container .devex-grid-nodata-container-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.card-header-gray {\n  // color: #4e5154 !important;\n  // background-color: #dae1e7 !important;\n}\n\n.card-header-light {\n  color: #4e5154 !important;\n  background-color: #f7f7f7 !important;\n}\n\n.card-header-white {\n  color: #4e5154 !important;\n  background-color: #fff !important;\n}\n\n.card-header-dark-blue {\n  color: #dae1e7 !important;\n  background-color: #3a4459 !important;\n}\n\n.dx-tabs-wrapper {\n  background-color: #f7f7f7;\n}\n\n// Increase constrast for font in dark mode text area in FF side card\n.dark-layout textarea.notes-input {\n  color: #2e2b3b !important;\n}\n\n.modal-progress {\n  position: absolute;\n  width: 50%;\n  top: 20%;\n  left: 50%;\n  transform: translate(-50%, -50%) !important;\n}\n\n.full-width {\n  width: 100%;\n}\n\n.left-align {\n  justify-content: flex-start;\n  display: flex;\n  align-items: center;\n}\n\n.right-align {\n  justify-content: flex-end;\n  display: flex;\n  align-items: center;\n}\n\n.center-align {\n  justify-content: center;\n  display: flex;\n  align-items: center;\n}\n\n.sweet-alert-confirm-btn,\n.sweet-alert-confirm-btn:focus,\n.sweet-alert-confirm-btn:active {\n  color: #fff !important;\n}\n\n.sweet-alert-cancel-btn,\n.sweet-alert-cancel-btn:focus,\n.sweet-alert-cancel-btn:active {\n  color: #00a0dd !important;\n}\n\n.sweetalert-wide {\n  width: 500px !important;\n}\n\n.sweetalert-narrow {\n  width: 280px !important;\n}\n\n.sweetalert-tag-inputs {\n  padding: 0 25px;\n}\n\n.sweetalert-narrow > p {\n  margin: 0 !important;\n}\n\n.dx-first-row.dx-last-col.dx-first-row.dx-first-row.dx-first-row > .dx-item-content .dx-box-item-content {\n  // width: '50px!important';\n  background-color: blue !important;\n  /* text-align: right!important; */\n}\n\n.align-right {\n  text-align: right;\n}\n\n.duration {\n  padding-top: 8px;\n  color: #84858c;\n}\n\n.image-item {\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s;\n}\n\n.image-item:hover {\n  transform: scale(1.05);\n}\n\n.image-item button {\n  opacity: 0.7;\n}\n\n.image-item button:hover {\n  opacity: 1;\n}\n","//  ================================================================================================\n//  File Name: variables.scss\n//  Description: Custom overrides of Bootstrap variables\n//  ----------------------------------------------------------------------------------------------\n//  Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n//  Author: PIXINVENT\n//  Author URL: http://www.themeforest.net/user/pixinvent\n//  ================================================================================================\n\n// Color system\n\n$white: #fdfeff !default;\n$gray-50: #f6f6f6 !default;\n$gray-100: #babfc7 !default; // $gray-lightest\n$gray-200: #ededed !default; // $gray-lighter\n$gray-300: #dae1e7 !default; // $gray-light\n$gray-400: #636363 !default;\n$gray-500: #adb5bd !default;\n$gray-600: #b8c2cc !default; // $gray\n$gray-700: #4e5154 !default;\n$gray-800: #1e1e1e !default; // $gray-dark\n$gray-900: #2a2e30 !default;\n$black: #1e1d2b !default; // 231f48 22292f\n\n$brand-dark-hover: #191923;\n$brand-dark-bg: #1e1d2b;\n$brand-purple: #5440d2;\n$brand-purple-hover: #3d2bb4;\n\n$sso-btn: #cfd0d2;\n$sso-btn-hover: #adaeb3;\n\n$purple: #9b67f0 !default; //$primary\n$green: #28c76f !default; //$success\n$blue: #00cfe8 !default; //$info\n$orange: #d56729 !default; //$warning\n$red: #de4827 !default; //$danger\n\n// Marketfuels Color Variables\n$mf-lightblue: #00a0dd !default;\n$mf-red: #de4827 !default;\n$mf-orange: #d56729 !default;\n$mf-navy: #222d69 !default;\n$mf-darkgrey: #232323 !default;\n$mf-lightgrey: #eeeeee !default;\n$mf-mdgrey: #2b2b2b !default;\n$mf-disabled-gray: #cfd0d2 !default;\n$mf-darkblue: #2b5995 !default;\n$mf-brown: #776a84 !default;\n$mf-success-green: #21984f !default;\n$mf-success-green-disabled: #acccb6 !default;\n\n$primary: $mf-lightblue !default;\n$secondary: $mf-red !default;\n$info: $mf-navy !default;\n$warning: $mf-orange !default;\n$light: $gray-50 !default;\n$medium-light: $mf-red !default;\n$dark: $mf-darkgrey !default;\n\n$card-header-bg: var(--mf-colors-surface) !default;\n$card-header-border: var(--mf-colors-surface) !default;\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1440px // Custom xxl size,,,,,,,,,,,,\n) !default;\n// scss-docs-end container-max-widths\n\n// stylelint-disable\n$spacer: 0.875rem !default;\n$spacers: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$spacers: map-merge(\n  (\n    0: 0,\n    25: (\n      $spacer * 0.25\n    ),\n    50: (\n      $spacer * 0.5\n    ),\n    75: (\n      $spacer * 0.75\n    ),\n    1: (\n      $spacer\n    ),\n    2: (\n      $spacer * 1.5\n    ),\n    3: (\n      $spacer * 3\n    ),\n    4: (\n      $spacer * 3.5\n    ),\n    5: (\n      $spacer * 4\n    )\n  ),\n  $spacers\n);\n\n// Body\n//\n// Settings for the `<body>` element.\n$body-bg: #f8f8f8 !default;\n$body-color: #6e6b7b !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color: $primary !default;\n$link-hover-color: darken($link-color, 5%) !default;\n$link-hover-decoration: none !default;\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-gutter-width: 1.75rem !default;\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg: 1.25 !default;\n$line-height-sm: 1 !default;\n\n$border-width: 1px !default;\n$border-color: #ebe9f1 !default;\n$border-radius: 0.3125rem !default;\n$border-radius-lg: 0.525rem !default;\n$border-radius-sm: 0.21875rem !default;\n\n// shadow\n$box-shadow: 0 4px 24px 0 rgba($black, 0.1) !default;\n// Typography\n\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif: 'Montserrat', Helvetica, Arial, serif !default;\n$font-family-monospace: 'Montserrat', Helvetica, Arial, serif !default;\n\n// stylelint-enable value-keyword-case\n$font-size-base: 0.875rem !default;\n$font-size-lg: ceil($font-size-base * 1.25) !default;\n$font-size-md: $font-size-base * 1.2 !default;\n$font-size-sm: ceil($font-size-base * 0.85) !default;\n\n$font-weight-normal: 400 !default;\n$font-weight-bold: 500 !default;\n$font-weight-bolder: 600 !default;\n\n$line-height-base: 1.45 !default;\n\n$h1-font-size: $font-size-base * 2 !default;\n$h2-font-size: $font-size-base * 1.714 !default;\n$h3-font-size: $font-size-base * 1.5 !default;\n$h4-font-size: $font-size-base * 1.286 !default;\n$h5-font-size: $font-size-base * 1.07 !default;\n\n$headings-font-family: inherit !default;\n$headings-color: #5e5873 !default;\n\n$display1-weight: $font-weight-normal !default;\n$display2-weight: $font-weight-normal !default;\n$display3-weight: $font-weight-normal !default;\n$display4-weight: $font-weight-normal !default;\n\n$lead-font-size: $font-size-base * 1.14 !default;\n$lead-font-weight: $font-weight-normal !default;\n\n$small-font-size: 0.75rem !default;\n\n$text-muted: #b9b9c3 !default;\n$hr-border-color: $border-color !default;\n\n$blockquote-small-color: $text-muted !default;\n\n// Tables\n\n$table-cell-padding: 0.625rem !default;\n\n$table-accent-bg: #fafafc !default;\n$table-hover-bg: #f6f6f9 !default;\n\n$table-border-color: $border-color !default;\n\n$table-head-bg: #f3f2f7 !default;\n$table-head-color: $headings-color !default;\n\n$table-dark-bg: $dark !default;\n$table-dark-border-color: #404040 !default;\n\n$table-th-font-size: 0.75rem !default; // custom\n\n// Buttons + Forms\n$btn-padding-y: 0.6875rem !default;\n$btn-padding-x: 1.3125rem !default;\n$input-btn-padding-y: 0.65625rem !default;\n$input-btn-padding-x: 1.75rem !default;\n\n$input-btn-padding-y-sm: 0.425rem !default;\n$input-btn-padding-x-sm: 0.875rem !default;\n$input-btn-font-size-sm: $font-size-base * 0.9 !default;\n\n$input-btn-padding-y-lg: 0.7rem !default;\n$input-btn-padding-x-lg: 1.75rem !default;\n$input-btn-font-size-lg: $font-size-base * 1.25 !default;\n$btn-line-height: 1 !default;\n$btn-border-radius: 0.313rem !default;\n$btn-border-radius-lg: 0.313rem !default;\n$btn-border-radius-sm: 0.313rem !default;\n\n$btn-transition:\n  color 0.15s ease-in-out,\n  background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out,\n  background 0s,\n  border 0s !default;\n\n// Forms\n$custom-control-border-color: #d8d6de;\n$label-margin-bottom: 0.25rem !default;\n\n$input-padding-y: 0.438rem !default;\n$input-padding-x: 1rem !default;\n$input-font-size: 1rem !default;\n$input-line-height: $line-height-base !default;\n\n$input-padding-y-sm: 0.188rem !default;\n$input-padding-x-sm: 0.857rem !default;\n$input-font-size-sm: 0.857rem !default;\n\n$input-padding-y-lg: 0.75rem !default;\n$input-padding-x-lg: 1.143rem !default;\n$input-font-size-lg: 1.143rem !default;\n\n$input-disabled-bg: #efefef !default;\n\n$input-color: $body-color !default;\n$input-border-color: $custom-control-border-color !default;\n$input-box-shadow: inset 0 1px 1px rgba($black, 0.075) !default;\n\n$input-border-radius: $border-radius !default;\n$input-border-radius-lg: $border-radius !default;\n$input-border-radius-sm: $border-radius !default;\n\n$input-focus-border-color: $primary !default;\n$input-focus-box-shadow: 0 3px 10px 0 rgba($black, 0.1) !default;\n\n$input-placeholder-color: $text-muted !default;\n$input-plaintext-color: $body-color !default;\n\n$input-height: 2.714rem !default;\n$input-height-sm: 2.142rem !default;\n$input-height-lg: 3.2857rem !default;\n\n$input-group-addon-bg: white !default;\n$custom-forms-transition:\n  background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out,\n  background 0s,\n  border-color 0s !default;\n\n$custom-control-indicator-border-color: $custom-control-border-color;\n\n$custom-checkbox-indicator-border-radius: 3px !default;\n$custom-checkbox-indicator-checked-color: white !default;\n$custom-checkbox-indicator-indeterminate-color: white !default;\n$custom-checkbox-indicator-icon-checked: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9.5 7.5'%3E%3Cpolyline points='0.75 4.35 4.18 6.75 8.75 0.75' style='fill:none;stroke:%23fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px'/%3E%3C/svg%3E\");\n\n$custom-checkbox-indicator-icon-indeterminate: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#{$custom-checkbox-indicator-indeterminate-color}' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-minus'%3E%3Cline x1='5' y1='12' x2='19' y2='12'%3E%3C/line%3E%3C/svg%3E\");\n\n$custom-control-indicator-checked-disabled-bg: rgba($primary, 0.65);\n\n$custom-radio-indicator-icon-checked: none;\n\n$custom-file-height-inner: $input-height !default;\n\n$custom-select-indicator-padding: 1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-disabled-bg: $input-disabled-bg !default;\n$custom-select-bg-size: 10px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color: $input-border-color !default;\n$custom-select-indicator: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n\n// $custom-select-feedback-icon-position: center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n// $custom-select-feedback-icon-size: $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-radius: $input-border-radius !default;\n$custom-select-focus-box-shadow: $input-focus-box-shadow !default;\n\n$custom-select-padding-y-sm: $input-padding-y-sm !default;\n$custom-select-padding-x-sm: $input-padding-x-sm !default;\n$custom-select-font-size-sm: $input-font-size-sm !default;\n$custom-select-height-sm: $input-height-sm !default;\n\n$custom-select-padding-y-lg: $input-padding-y-lg !default;\n$custom-select-padding-x-lg: $input-padding-x-lg !default;\n$custom-select-font-size-lg: $input-font-size-lg !default;\n$custom-select-height-lg: $input-height-lg !default;\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-border-color: rgba($black, 0.05) !default;\n$dropdown-border-radius: 0.358rem !default;\n$dropdown-box-shadow: 0 5px 25px rgba($black, 0.1) !default;\n\n$dropdown-link-color: $body-color !default;\n$dropdown-link-hover-color: $primary !default;\n$dropdown-link-hover-bg: rgba($primary, 0.12) !default;\n\n$dropdown-divider-bg: rgba($black, 0.08) !default;\n$dropdown-font-size: 1rem !default;\n$dropdown-spacer: 0 !default;\n$zindex-dropdown: 10 !default;\n\n$dropdown-box-shadow: 0 5px 25px 0 rgba($black, 0.1) !default;\n\n$dropdown-link-disabled-color: $text-muted !default;\n\n$dropdown-item-padding-y: 0.65rem !default;\n$dropdown-item-padding-x: 1.28rem !default;\n\n$dropdown-header-color: $headings-color !default;\n\n$dropdown_spacing: 0.5rem; // custom\n\n// Pagination\n\n$pagination-padding-y: 0.5rem !default;\n$pagination-padding-x: 0.85rem !default;\n$pagination-padding-y-lg: 0.5575rem !default;\n$pagination-padding-x-lg: 1rem !default;\n$pagination-padding-y-sm: 0.443rem !default;\n$pagination-padding-x-sm: 0.745rem !default;\n\n$pagination-disabled-color: $text-muted !default;\n\n$pagination-color: $body-color !default;\n$pagination-bg: #f3f2f7 !default;\n\n$pagination-hover-color: $primary !default;\n$pagination-hover-bg: #f3f2f7 !default;\n\n$pagination-active-color: $primary !default;\n\n$pagination-disabled-color: $text-muted !default;\n$pagination-disabled-bg: #f3f2f7 !default;\n\n$pagination-font-size-lg: 1.14rem !default; // custom\n$pagination-font-size-sm: 0.857rem !default; // custom\n\n// Cards\n$card-spacer-y: 1.5rem !default;\n$card-spacer-x: 1.5rem !default;\n$card-border-radius: 0.428rem !default;\n\n//Alerts\n\n$alert-padding-y: 0.71rem !default;\n$alert-padding-x: 1rem !default;\n$alert-border-radius: 0.358rem !default;\n$alert-link-font-weight: 700 !default;\n\n// List group\n\n$list-group-border-radius: 0.358rem !default;\n$list-group-disabled-color: $text-muted !default;\n\n// Nav tabs\n\n$nav-link-padding-y: 0.358rem !default;\n$nav-link-padding-x: 0.5rem !default;\n$nav-link-disabled-color: $text-muted !default;\n\n$nav-tabs-border-width: 0 !default;\n$nav-tabs-border-radius: 0.25 !default;\n$nav-tabs-link-active-color: $primary !default;\n\n$nav-tabs-link-active-bg: transparent !default;\n\n$nav-pills-border-radius: $btn-border-radius !default;\n$nav-tabs-bg-dark: #323232 !default;\n\n// navbar\n\n$floating-nav-margin: remSizing(1.3);\n\n// Tooltips\n\n$tooltip-bg: #323232 !default;\n$tooltip-padding-y: 0.35rem !default;\n$tooltip-padding-x: 0.678125rem !default;\n$tooltip-font-size: 0.75rem !default;\n$tooltip-border-radius: 0.3125rem !default;\n$tooltip-opacity: 1 !default;\n$tooltip-max-width: 220px !default;\n\n// Popovers\n\n$popover-font-size: 0.875rem !default;\n$popover-border-width: 0 !default;\n$popover-border-radius: 0.3125rem !default;\n$popover-border-color: $border-color !default;\n$popover-box-shadow: 0 0 10px 0 rgba($black, 0.1) !default;\n\n$popover-header-bg: $primary !default;\n$popover-header-color: $white !default;\n$popover-header-padding-y: 0.5625rem !default;\n$popover-header-padding-x: 1.0625rem !default;\n\n// Toasts\n\n$toast-max-width: 380px !default;\n$toast-padding-x: 1rem !default;\n$toast-padding-y: 0.125rem !default;\n$toast-font-size: 0.75rem !default;\n$toast-color: $body-color !default;\n$toast-border-width: 0 !default;\n$toast-border-radius: 0.25rem !default;\n$toast-box-shadow: 0 2px 20px 0 rgba($black, 0.08) !default;\n\n$toast-header-color: $body-color !default;\n$toast-header-background-color: $white !default;\n\n// Progress\n\n$progress-height: 0.75rem !default;\n$progress-border-radius: 4.375rem !default;\n$progress-font-size: $font-size-base * 0.857 !default;\n$progress-bg: rgba($primary, 0.12) !default;\n\n// Breadcrumbs\n\n$breadcrumb-font-size: 0.875rem !default;\n\n// $breadcrumb-padding-y: remSizing(0.3) !default;\n$breadcrumb-item-padding: 0.525rem !default;\n\n$breadcrumb-margin-bottom: 0 !default;\n\n$breadcrumb-bg: transparent !default;\n$breadcrumb-divider-color: $body-color !default;\n$breadcrumb-active-color: $body-color !default;\n\n$breadcrumb-border-radius: 0 !default;\n\n// Carousel\n\n$carousel-control-color: $white !default;\n$carousel-control-prev-icon-bg: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#{$carousel-control-color}\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-left\"><polyline points=\"15 18 9 12 15 6\"></polyline></svg>') !default;\n$carousel-control-next-icon-bg: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#{$carousel-control-color}\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-right\"><polyline points=\"9 18 15 12 9 6\"></polyline></svg>') !default;\n\n// Badges\n\n$badge-font-size: 85% !default;\n$badge-padding-y: 0.2625rem !default;\n$badge-padding-x: 0.4375rem !default;\n$badge-font-weight: 600 !default;\n$badge-border-radius: 0.3125rem !default;\n\n$badge-pill-padding-x: 0.4375rem !default;\n\n// Modal\n$modal-inner-padding: 0.7rem 1.225rem !default;\n\n$modal-footer-border-color: rgba($black, 0.05) !default;\n\n$modal-header-padding-y: 0.7rem !default;\n$modal-header-padding-x: 1.225rem !default;\n$modal-content-border-radius: 0.3125rem !default;\n\n$modal-xl: 94% !default;\n$modal-sm: 400px !default;\n\n//    Slide In Modal\n$modal-slide-in-width-sm: 21.875rem !default; // custom\n$modal-slide-in-width: 24.5rem !default; // custom\n$modal-slide-in-width-lg: 26.25rem !default; // custom\n\n// Close\n\n$close-font-size: $font-size-base * 2 !default;\n$close-font-weight: 400 !default;\n$close-color: $headings-color !default;\n\n// Code\n\n$code-font-size: 90% !default;\n$kbd-bg: #eee !default;\n\n// Switch\n$custom-switch-width: 2.625rem !default;\n$custom-switch-indicator-border-radius: 0.875rem !default;\n$custom-switch-indicator-size: 0.875rem !default;\n\n//svg color\n$svg-color-light: #626262 !default;\n\n// SVG icons\n// For Breadcrumb\n$double-chevron-right: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevrons-right'%3E%3Cpolyline points='13 17 18 12 13 7'%3E%3C/polyline%3E%3Cpolyline points='6 17 11 12 6 7'%3E%3C/polyline%3E%3C/svg%3E\";\n// Chevron Icons\n$chevron-left: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\";\n$chevron-right: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\";\n$chevron-up: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E\";\n$chevron-down: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\";\n\n$download: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-download'%3E%3Cpath d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4'%3E%3C/path%3E%3Cpolyline points='7 10 12 15 17 10'%3E%3C/polyline%3E%3Cline x1='12' y1='15' x2='12' y2='3'%3E%3C/line%3E%3C/svg%3E\";\n$remove: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-x'%3E%3Cline x1='18' y1='6' x2='6' y2='18'%3E%3C/line%3E%3Cline x1='6' y1='6' x2='18' y2='18'%3E%3C/line%3E%3C/svg%3E\";\n$check: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-check'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E\";\n$circle: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-circle'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3C/svg%3E\";\n$infoIcon: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-info'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cline x1='12' y1='16' x2='12' y2='12'%3E%3C/line%3E%3Cline x1='12' y1='8' x2='12.01' y2='8'%3E%3C/line%3E%3C/svg%3E\";\n$warningIcon: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-alert-triangle'%3E%3Cpath d='M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z'%3E%3C/path%3E%3Cline x1='12' y1='9' x2='12' y2='13'%3E%3C/line%3E%3Cline x1='12' y1='17' x2='12.01' y2='17'%3E%3C/line%3E%3C/svg%3E\";\n$menu: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' stroke='currentColor' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round' class='css-i6dzq1'%3E%3Cline x1='3' y1='12' x2='21' y2='12'%3E%3C/line%3E%3Cline x1='3' y1='6' x2='21' y2='6'%3E%3C/line%3E%3Cline x1='3' y1='18' x2='21' y2='18'%3E%3C/line%3E%3C/svg%3E\";\n\n$chat-bg-light: 'data:image/svg+xml;base64,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';\n$chat-bg-dark: 'data:image/svg+xml;base64,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';\n\n@function remSizing($num) {\n  @return #{$num * 0.875}rem;\n}\n\n@function remSpace($num) {\n  @return #{remSizing(($num * 4) / 16)};\n}\n\n@function pxSpace($num) {\n  @return #{$num}px;\n}\n\n$space-0: remSpace(0);\n$space-05: pxSpace(2);\n$space-1: remSpace(1);\n$space-2: remSpace(2);\n$space-3: remSpace(3);\n$space-4: remSpace(4);\n$space-5: remSpace(5);\n$space-6: remSpace(6);\n$space-8: remSpace(8);\n$space-10: remSpace(10);\n$space-12: remSpace(12);\n$space-16: remSpace(16);\n$space-20: remSpace(20);\n$space-24: remSpace(24);\n$space-28: remSpace(28);\n$space-32: remSpace(32);\n$space-36: remSpace(36);\n$space-40: remSpace(40);\n$space-44: remSpace(44);\n$space-48: remSpace(48);\n$space-52: remSpace(52);\n$space-56: remSpace(56);\n$space-60: remSpace(60);\n","html body .app.flex-row.align-items-center {\n  height: 100vh;\n}\n\n// ie11 floating footer temp fix, react only\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  #root {\n    display: flex;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
